import './App.css';
import { useEffect, useRef, useState, React, lazy, Suspense } from "react";
import { Checkbox, Button, FloatButton, Dropdown, message, Modal, Tour, Image, Space } from 'antd';
import AMapLoader from '@amap/amap-jsapi-loader';
import sixPathJson from './Paths/sixPath.json';
import { nohighday } from './data/nohighday';

import loadingGIF from './images/loading.gif';
import exchangePNG from './images/exchange.png';
import dirMark from './images/dir-marker.png';
import markerRed from './images/marker-red.png';
import delWay from './images/delWay.png';
import camPot from './images/camare.png';
import camTem from './images/camare-magenta.png';
import camNew from './images/camare-purple.png';
import camHigh from './images/camare-cyan.png';
import locate from './images/locate.png'

import { isMobile, isIOS, isAndroid, isMobileOnly } from 'react-device-detect';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import axios from 'axios';
import Icon, {
    LikeTwoTone, UpOutlined, DownOutlined, UserOutlined, SmileOutlined, PlusOutlined, MinusOutlined,
    StarOutlined, AimOutlined, CarTwoTone, ExclamationCircleFilled
} from '@ant-design/icons';

import LastUpdate from './pages/LastUpdate';

import { formatSeconds, similarity } from './Utils/Util';
import { v4 as uuidv4 } from 'uuid';
import sha1 from 'js-sha1'
import { stringSimilarity } from "string-similarity-js";
import starDemo from './images/star-demo.png';
import sixDemo from './images/six-demo.png'



const TimeLinePage = lazy(
    () => import('./pages/TimeLinePage')
)
const AuthorPage = lazy(
    () => import('./pages/AuthorPage')
);
const SupportPage = lazy(
    () => import('./pages/SupportPage')
);
const LoginPage = lazy(
    () => import('./pages/LoginPage')
);
const StarPage = lazy(
    () => import('./pages/StarPage')
);
const SixDoorPage = lazy(
    () => import('./pages/SixDoorPage')
);


var _ = require('lodash');

const sixPath = sixPathJson;

const { confirm } = Modal;

const App = () => {

    const _env = process.env?.NODE_ENV;

    //const violation = `使用方式：<br/>1、下载安卓APP</br>百度网盘：https://pan.baidu.com/s/1F4Zj8yzPdb5AzC7UiujLpg?pwd=4urh<br/>夸克网盘：https://pan.quark.cn/s/b3ddae9c463e<br/>2、手机浏览器 https://wintersir.com/?version=2<br/>3、关注公众号《别拍我》底部菜单“走你”`;
    const violation = "暂不支持，请联系作者"
    const [loadingText, setLoadingText] = useState("玩命加载中")

    //弹窗计时器
    let intval = null;

    //app配置
    const [appSetting, setAppSetting] = useState(null);
    const [authorShow, setAuthorShow] = useState(true);
    const [tourOpen, setTourOpen] = useState(false);
    const ref0 = useRef(null);
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);

    const TourSteps = [
        {
            title: '路线',
            description: <div className='text-tip'>输入地址，或单击地图任意点设置 起、终、途径，<br></br>点击 “走你” 规划路线，成功后可导航、收藏</div>,
            target: () => ref0.current,
        },
        {
            title: '更新',
            description: <div className='text-tip'>点击查看近期更新的摄像头，及使用小技巧</div>,
            placement: "topRight",
            target: () => ref1.current,
        },
        {
            title: '摄像头',
            description: <div className='text-tip'>勾选显示所有摄像头，点击{<UpOutlined />}显示详细分类</div>,
            placement: "topLeft",
            target: () => ref2.current,
        },
        {
            title: '用户',
            description: <div className='text-tip'>登录、注册、重置密码、查看会员信息</div>,
            placement: "topRight",
            target: () => ref4.current,
        },
        {
            title: '收藏夹',
            description: <div className='text-tip'>查看收藏的地点、路线、自定义不拍的摄像头，快速设置起点、终点、及路线</div>,
            placement: "leftBottom",
            cover: (
                <img
                    style={{ maxWidth: 330, width: window.screen.width - 100 }}
                    alt="收藏夹"
                    src={starDemo}
                />
            ),
            target: () => ref5.current,
        },
        {
            title: '六环',
            description: <div className='text-tip'>显示起点、终点附近，及全部的六环出入口，六环自动算路功能，长途规划更轻松</div>,
            placement: "leftBottom",
            cover: (
                <img
                    style={{ maxWidth: 340, width: window.screen.width - 100 }}
                    alt="六环"
                    src={sixDemo}
                />
            ),
            target: () => ref6.current,
        },
        {
            title: '功能',
            description: <div className='text-tip'>更新记录，点击链接查看文字详情，视频播放需到公众号文章查看</div>,
            placement: "leftBottom",
            target: () => ref7.current,
        }
    ];

    // 摄像头较多，全部、最新分开获取，减少带宽小的影响
    const [camera, setCamera] = useState([]);
    const [newCamera, setNewCamera] = useState([]);
    const [userExcludeCamera, setUserExcludeCamera] = useState([]) //用户已排除的摄像头
    const userExcludeCameraRef = useRef([]);
    const [validCamera, setValidCamera] = useState([]);//全部摄像头获取后，直接分区，减少算路循环所需时间
    const [camImageUrl, setCamImageUrl] = useState("");
    const [camImageOpen, setCamImageOpen] = useState(false);


    //六环出入口
    const [sixdoor, setSixdoor] = useState([]);
    const [sixDoorOpen, setSixDoorOpen] = useState(false);
    const [sixDoorAuto, setSixDoorAuto] = useState(false);
    const [sixDoorMode, setSixDoorMode] = useState(2);
    const [startCloserSixDoor, setStartCloserSixDoor] = useState([]);
    const [endCloserSixDoor, setEndCloserSixDoor] = useState([]);
    const autoIndexRef = useRef(null);   // 记录当前算路的索引，当索引=起终点六环口相加数量-1时，则是计算完毕，改变 autoOver
    const autoOverRef = useRef(false);   // 自动算路是否开始
    const autoRoutesRef = useRef([]);    // 自动算路集合，找最优用
    const [autoRoutesShow, setAutoRoutesShow] = useState(false);

    // Author
    const urlParams = new URLSearchParams(window.location.search);
    let who = urlParams.get("who");
    if (window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        who = 'gzh';
    }
    const version = 2;// urlParams.get("version");

    //导航按钮、参数
    const [naviVisable, setNaviVisable] = useState(false);
    const [naviParam, setNaviParam] = useState(null);
    const [naviSchemeUrl, setNaviSchemeUrl] = useState(null);

    // 地图相关对象
    const [map, setMap] = useState(null);
    const mapRef = useRef(null);
    const [AMap, setAMap] = useState(null);
    const [mass, setMass] = useState(true);

    // 摄像头显示开关
    const [showCamera, setShowCamera] = useState([]);
    const [cameraMore, setCameraMore] = useState(false);

    const [beijing, setBeijing] = useState([]);
    // 通州、延庆，行政区域边界
    const [tongZhou, setTongZhou] = useState([]);
    const [yanQing, setYanQing] = useState([]);
    const [shunYi, setShunYi] = useState([]);

    // 需要清除的标记
    const polylineRef = useRef(null);     //规划成功的路线
    const redPolylineRef = useRef(null); //最少途经点算路结果
    const camareMarkRef = useRef(null);   //摄像头点击显示的信息
    const startMarkRef = useRef(null);    //起点
    const viaMarkRef = useRef(null);      //途径点
    const endMarkRef = useRef(null);      //终点
    const longMarkRef = useRef(null);     //选点
    const locateRef = useRef(null);       //定位

    // 设置途经点
    const viaRef = useRef([]);
    const [viaState, setViaState] = useState(null);
    const [refresh, setRefresh] = useState(null);
    const routeViaMarkRef = useRef([]);

    // 更新弹框
    const [updateOpen, setUpdateOpen] = useState(false)
    const [updateClose, setUpdateClose] = useState(5)
    const [supportOpen, setSupportOpen] = useState(false)

    // 未读
    const [read, setRead] = useState(true);

    // 时间线
    const [timeLineVisible, setTimeLineVisible] = useState(false);
    const [timelineData, setTimelineData] = useState([]);

    // 登录
    const [loginOpen, setLoginOpen] = useState(false);
    const [device, setDevice] = useState(null);
    const [user, setUser] = useState(null);
    const userRef = useRef(null);
    const [payVip, setPayVip] = useState(false);//六环算路仅对 付费会员 开放
    const [vip, setVip] = useState(false);
    const vipRef = useRef(null);
    const [repeatUser, setRepeatUser] = useState(false);

    const [totalRemain, setTotalRemain] = useState(0);
    const [remain, setRemain] = useState("")//今日剩余次数
    const [vipInfoOpen, setVipInfoOpen] = useState(false);

    // 收藏
    const [starTip, setStarTip] = useState(false);//收藏成功，收藏夹按钮位置提示
    const [starOpen, setStarOpen] = useState(false);//收藏夹
    const [starVisable, setStarVisable] = useState(false);//收藏路线按钮

    // 避让区域x、y增加范围常量
    const toleranceX = 0.00003;
    const toleranceY = 0.00002;

    // android 定位、
    const GaolocationRef = useRef(null);

    // 微信sdk
    const [access_token, setAccess_token] = useState(null)
    const [jsapi_ticket, setJsapi_ticket] = useState(null)

    // 应对QPS
    const restapiErrorRef = useRef(false);


    const allowinit = _env == "development" || isMobile || isAndroid || isIOS || who == "jd"   //仅允许在移动端访问

    /* 初始化 */
    useEffect(() => {
        if (!allowinit)
            return false

        //带版本号的链接，证明app已更新至支持缓存的版本（大于 v1.1）
        if (version >= 2) {
            if (localStorage.getItem("user") != null) {
                getUser()
            }

            //android webview 需要设置缓存开启，否则会报错，后续数据都放数据库
            if (localStorage.getItem("read") != null) {
                setRead(false);
            }
        }

        //获取配置
        axios.get('/api/appsetting').then(function (response) {
            setAppSetting(response.data);
            setTotalRemain(response.data.totalremain)
        }).catch(function (error) {
            console.log("/appsetting" + error);
            setLoadingText("若无法正常加载，请更新至最新版本！")
        })


        //先获取最新摄像头
        axios.get('/api/newcameras').then(function (response) {
            const dbcameras = response.data?.map(c => {
                c.position = JSON.parse(c.position);
                return c;
            });
            setNewCamera(dbcameras);
        }).catch(function (error) {
            console.log("/newcameras" + error);
        })

        //再获取全部摄像头
        axios.get('/api/cameras').then(function (response) {
            const dbcameras = response.data?.map(c => {
                c.position = JSON.parse(c.position);
                return c;
            });

            setCamera(dbcameras)

            // message.success("再获取全部摄像头成功");
        }).catch(function (error) {
            message.error("请求错误");
        })

        //时间线
        axios.get('/api/timeline').then(function (response) {
            if (version >= 2) {
                const orderData = _.orderBy(response.data, 'time', 'desc');
                if (localStorage.getItem("read") != null && dayjs(orderData[0].time) >= dayjs(localStorage.getItem("read"))) {
                    localStorage.removeItem("read");
                    setRead(true);
                }
            }
            setTimelineData(response.data);
        }).catch(function (error) {
            console.log("/api/timeline" + error);
        })

        //六环口
        axios.get('/api/sixdoor').then(function (response) {
            setSixdoor(response.data);

        }).catch(function (error) {
            console.log("/api/timeline" + error);
        })

        return () => {
            clearInterval(intval);
            if (map) {
                map.destroy();
            }
            // AMapLoader.reset();
        }
    }, [])

    // 初始化地图
    useEffect(() => {

        if (allowinit) {

            if (appSetting != null) {

                window._AMapSecurityConfig = {
                    securityJsCode: appSetting.jskeysecret,//"d360b45265a6b65016eca2fb8d59da48"//
                };
                if (!window.AMap) {
                    AMapLoader.load({
                        key: appSetting.jskey, //  申请好的Web端开发者Key，首次调用 load 时必填 //"c2d8624cfd8ff1058ab6e3ea23d9a779",//
                        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                        plugins: ["AMap.PlaceSearch", "AMap.AutoComplete", "AMap.DistrictSearch", "AMap.Geocoder", "AMap.Geolocation"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
                    }).then((_AMap) => {
                        const _map = new _AMap.Map("container", {
                            resizeEnable: true,
                            viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D'
                            zoom: 11, // 初始化地图层级
                            center: [116.397428, 39.93000] // 初始化地图中心点
                        });
                        _map.on('complete', () => {
                            setAMap(_AMap);
                        });

                        document.getElementsByClassName("amap-logo")[0]?.remove();
                        document.getElementsByClassName("amap-copyright")[0]?.remove();

                        setMap(_map);

                        let district = new _AMap.DistrictSearch({
                            subdistrict: 0,   //获取边界不需要返回下级行政区
                            extensions: 'all',  //返回行政区边界坐标组等具体信息
                            level: 'city'  //查询行政级别为 市
                        });

                        if (localStorage.getItem('tongZhouCache')) {
                            setTongZhou(JSON.parse(localStorage.getItem('tongZhouCache')));
                        } else {
                            district.search("通州区", (status, result) => {
                                const bounds = result.districtList[0].boundaries;
                                if (bounds) {
                                    for (var i = 0; i < bounds.length; i += 1) {//构造MultiPolygon的path
                                        bounds[i] = [bounds[i]]
                                    }
                                    localStorage.setItem("tongZhouCache", JSON.stringify(bounds))
                                    setTongZhou(bounds);
                                }
                            })
                        }

                        if (localStorage.getItem('yanQingCache')) {
                            setYanQing(JSON.parse(localStorage.getItem('yanQingCache')));
                        } else {
                            //延迟执行，解决qps
                            setTimeout(() => {
                                district.search("延庆区", (status, result) => {
                                    const bounds = result.districtList[0].boundaries;
                                    if (bounds) {
                                        for (var i = 0; i < bounds.length; i += 1) {//构造MultiPolygon的path
                                            bounds[i] = [bounds[i]]
                                        }
                                        localStorage.setItem("yanQingCache", JSON.stringify(bounds))
                                        setYanQing(bounds);
                                    }
                                })
                            }, 1000);
                        }

                        if (localStorage.getItem('shunYiCache')) {
                            setShunYi(JSON.parse(localStorage.getItem('shunYiCache')));
                        } else {
                            setTimeout(() => {
                                district.search("顺义区", (status, result) => {
                                    const bounds = result.districtList[0].boundaries;
                                    if (bounds) {
                                        for (var i = 0; i < bounds.length; i += 1) {//构造MultiPolygon的path
                                            bounds[i] = [bounds[i]]
                                        }
                                        localStorage.setItem("shunYiCache", JSON.stringify(bounds))
                                        setShunYi(bounds);
                                    }
                                })
                            }, 2000);
                        }

                        if (localStorage.getItem('beiJingCache')) {
                            setBeijing(JSON.parse(localStorage.getItem('beiJingCache')));
                        } else {
                            setTimeout(() => {
                                district.search("北京市", (status, result) => {
                                    const bounds = result.districtList[0].boundaries;
                                    if (bounds) {
                                        for (var i = 0; i < bounds.length; i += 1) {//构造MultiPolygon的path
                                            bounds[i] = [bounds[i]]
                                        }
                                        localStorage.setItem("beiJingCache", JSON.stringify(bounds))
                                        setBeijing(bounds);
                                    }
                                })
                            }, 3000);
                        }

                    }).catch((e) => {
                        console.log(e);
                    });
                }
            }
        }

    }, [appSetting])

    useEffect(() => {
        mapRef.current = map
    }, [map])

    // vip 初始化文本框自动提示
    useEffect(() => {
        if (AMap !== null) {
            loadMap();
            //调试用
            //createSixPolygon()
        }
    }, [AMap])

    // 地图加载后，初始化地图点击事件，初始化定位
    useEffect(() => {
        if (map != null && AMap != null) {

            map.on('click', mapClick)

            // 浏览器原生定位，限 HTTPS、或者 localhost
            if (who != "gzh" && who != "android") {
                BrowserLocation()
            }

            //#region web https 高德定位
            // if (who != "android" && who != "ios") {
            //     var geolocation = new AMap.Geolocation({
            //         enableHighAccuracy: true,//是否使用高精度定位，默认:true
            //         timeout: 5000,          //超过10秒后停止定位，默认：5s
            //         convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            //         position: 'RB',    //定位按钮的停靠位置
            //         offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
            //         showCircle: false,
            //         zoomToAccuracy: false,   //定位成功后是否自动调整地图视野到定位点
            //     });
            //     // map.addControl(geolocation);
            //     geolocation.getCurrentPosition(function (status, result) {
            //         if (status == 'complete') {
            //             console.log("Your GaoJS current position is:" + lngLatToString(result.position));
            //             document.getElementById("txtStart").value = "我的位置"
            //             setStartAndEnd(result.position, 1)
            //             map.setZoomAndCenter(16, result.position, true);
            //         } else {
            //             message.warning("定位失败")
            //         }
            //     });
            // }
            //#endregion

            // android 定位成功，设置起点为 “我的位置”
            if (GaolocationRef.current != null) {
                const lnglat = stringToLngLat(GaolocationRef.current.position);
                setStartAndEnd(lnglat, 1, "我的位置");
                map.setZoomAndCenter(16, lnglat, true);
                GaolocationRealAddress(lnglat)
            }
        }
    }, [map, AMap])


    // 初始化弹框，最新摄像头
    useEffect(() => {
        if (newCamera.length > 0) {

            loading(false);

            //如果处于导览模式，则不显示更新提示
            if (tourOpen == true) {
                return
            }

            setUpdateOpen(true)
            setTimeout(() => {
                setUpdateOpen(false);
            }, updateClose * 1000);

            intval = setInterval(() => {
                if (updateClose >= 0) {
                    setUpdateClose(d => d - 1)
                }
            }, 1000);
        }
    }, [newCamera])

    //排除摄像头后再分区，提高算路效率
    useEffect(() => {
        try {
            if (camera.length > 0) {
                const exludeids = userExcludeCamera.map(c => c.id);
                const resultArray = {
                    "110101": [],
                    "110102": [],
                    "110105": [],
                    "110106": [],
                    "110107": [],
                    "110108": [],
                    "110109": [],
                    "110111": [],
                    "110112": [],
                    "110113": [],
                    "110114": [],
                    "110115": [],
                    "110116": [],
                    "110117": [],
                    "110118": [],
                    "110119": []
                }

                // 过滤掉临时不拍的，和用户自定义不拍的
                camera.map(c => {
                    if (c.temp != true && !exludeids.includes(c.id)) {
                        c.cp = new AMap.LngLat(c.position[0], c.position[1]);
                        c.wayPolygon = createCamarePolygon(c);
                        resultArray[c.adcode].push(c)
                    }
                })
                setValidCamera(resultArray);
            }
        } catch (error) {
            console.log("error" + error)
        }

    }, [camera, userExcludeCamera])

    useEffect(() => {
        if (viaRef.current.length > 0) {
            setViaState(viaRef.current[0])
        } else {
            setViaState(null);
        }
    }, [viaRef.current])

    useEffect(() => {
        if (viaState != null)
            document.getElementById("txtVia").value = viaState.text
    }, [viaState])

    // 初始化 accesstoken
    useEffect(() => {
        if (appSetting != null && who == 'gzh') {
            //判断 accesstoken 过期
            if (appSetting.access_token != null && appSetting.access_token != "" && dayjs(appSetting.access_token_time) > dayjs()) {
                setAccess_token(appSetting.access_token)
                setJsapi_ticket(appSetting.jsapi_ticket)
            } else {
                setAccess_token(null)
                setJsapi_ticket(null)
                setTimeout(() => {
                    axios.get('/accesstoken/cgi-bin/token?grant_type=client_credential&appid=wxeddff49a3d29eb67&secret=12fc17f5dea8b6ed50c3cda2016edcd4').then(function (response1) {
                        if (response1.data.access_token) {
                            setAccess_token(response1.data.access_token);
                            axios.get('/accesstoken/cgi-bin/ticket/getticket?access_token=' + response1.data.access_token + '&type=jsapi').then(function (response2) {
                                if (response2.data.ticket) {
                                    setJsapi_ticket(response2.data.ticket);

                                    axios.post('/api/updatewxconfig', { access_token: response1.data.access_token, jsapi_ticket: response2.data.ticket })
                                }
                            }).catch(function (error) {
                                console.log("jsapi_ticket_error" + error.stack);
                            })
                        }
                    }).catch(function (error) {
                        console.log("access_token_error" + error.stack);
                    })
                }, 100);
            }
        }
    }, [appSetting])

    // 初始化 wxconfig
    useEffect(() => {
        if (access_token != null && jsapi_ticket != null && map != null && AMap != null) {
            let nonceStr = uuidv4().replaceAll("-", "");
            let timestamp = new Date().getTime();
            let url = window.location.href;
            const objKeySort = (arys) => {
                //先用Object内置类的keys方法获取要排序对象的属性名数组，再利用Array的sort方法进行排序
                var newkey = Object.keys(arys).sort()
                var newObj = '' //创建一个新的对象，用于存放排好序的键值对
                for (var i = 0; i < newkey.length; i++) {
                    //遍历newkey数组
                    newObj += [newkey[i]] + '=' + arys[newkey[i]] + '&'
                }
                return newObj.substring(0, newObj.length - 1)
            }
            let sortStr = objKeySort({
                jsapi_ticket: jsapi_ticket,
                noncestr: nonceStr,
                timestamp: timestamp,
                url: url
            })

            let signature = sha1(sortStr)

            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: 'wxeddff49a3d29eb67', // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: nonceStr, // 必填，生成签名的随机串
                signature: signature,// 必填，签名
                jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
            });

            wx.ready(function () {
                WXGetLocation();
            })
            wx.error(function (res) {
                message.warning("定位失败")
                console.log("wx.ready error:" + JSON.stringify(res))
            });
        }
    }, [access_token, jsapi_ticket, map, AMap])

    // 初始化 user vip
    useEffect(() => {
        userRef.current = user;
        if (user != null) {
            clear();
            UpdateDeviceAndAppVersion();
            LoadTour();//漫游
            getUserExcludeCamera(); //如果是vip，则获取排除摄像头列表

            if (dayjs(user.expiretime) > dayjs()) {
                setVip(true)
                getUserIsPayVip();

            }
            else {
                setVip(false);
                setPayVip(false);
                // setTotalRemain(3)
                getRemain()
            }

            if (AMap !== null) {
                loadMap();
            }


        } else {
            setVip(false)
        }
    }, [user])

    useEffect(() => {
        if (totalRemain > 0) {
            getRemain()
        }
    }, [totalRemain])

    // vip 初始化文本框自动提示
    useEffect(() => {
        vipRef.current = vip;

        if (AMap !== null) {
            loadMap();
        }
    }, [vip])

    useEffect(() => {
        if (sixDoorAuto == false && viaRef.current.length > 0) {
            clearVia(0);
        }
    }, [sixDoorAuto])

    let lockMapClick = false;
    // 创建多边形（六环）
    const createSixPolygon = () => {
        new AMap.Polygon({
            map: map,
            fillOpacity: 0.3,
            path: sixPath.map(p => new AMap.LngLat(p[0], p[1]))
        });
    }

    // 底图点击回调
    const mapClickCallBack = (lnglat, address, byname) => {
        let Icon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(20, 29),
            // 图标的取图地址
            image: markerRed,
            // 图标所用图片大小
            imageSize: new AMap.Size(20, 29),
        });
        let position = lngLatToString(lnglat);
        const mark = new AMap.Marker({
            position: lnglat,
            icon: Icon,
            anchor: 'bottom-center',
            label: {
                content: `<div class="markInfo">${byname}</div>
                                <div id="startButton" class="markButton blue">起</div>`
                    + `<div id="viaButton" class="markButton via">经</div>`
                    + `<div id="endButton" class="markButton red">终</div>`
                    + `<div id="starButton" class="markButton star">收</div>`
                    + `<div class='mark-close' id='clickMark'>X</div>`,
                offset: new AMap.Pixel(0, -3),
                direction: 'top',
            }
        });

        mark.setMap(map);
        longMarkRef.current = mark


        setTimeout(() => {
            document.getElementById("startButton").onclick = () => {
                setStartAndEnd(lnglat, 1, address)
                mapRemove(mark)
                //document.getElementById("txtStart").value = address;
            }

            document.getElementById("viaButton").onclick = () => {
                setVia(lnglat, address)
            }

            document.getElementById("endButton").onclick = () => {
                setStartAndEnd(lnglat, 2, address)
                mapRemove(mark)
                //document.getElementById("txtEnd").value = address;
            }

            document.getElementById("clickMark").onclick = () => {
                mapRemove(mark)
            }

            document.getElementById("starButton").onclick = () => {
                axios.post('/api/addcollect', { userid: userRef.current.id, address: address, position: position, byname: (byname.trim() == "" ? address : byname) }).then(function (response) {
                    if (response.data == "code1") {
                        log("真的不能再多了")
                    } else {
                        message.success({ content: "收藏成功", style: { marginTop: "100px" } });
                        mapRemove(mark);
                        setStarTip(true);
                        setTimeout(() => {
                            setStarTip(false);
                        }, 2000);
                    }
                }).catch(function (error) {
                    console.log("/addcamera" + error);
                    log("收藏地点失败");
                })
            }
        }, 10);
    }

    const mapClickGeocoder = (e, address) => {
        var geocoder = new AMap.Geocoder({
            city: "010", // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        });
        // 逆地理编码
        geocoder.getAddress(e.lnglat, function (status, result) {

            lockMapClick = false;

            let addressdeal = "";
            let addressComponent = "";

            if (status === 'complete' && result.regeocode) {
                addressdeal = result.regeocode.formattedAddress.replace('北京市', '').replace('(建设中)', '');
                addressComponent = result.regeocode.addressComponent;
                if (addressdeal.length > 10) {
                    address = addressComponent.district + addressComponent.township + addressComponent.street + addressComponent.streetNumber;
                } else {
                    address = addressdeal;
                }

            }
            const byname = addressdeal.replace(addressComponent.district, '')
                .replace(addressComponent.township, '')
            // .replace(addressComponent.street, '')
            // .replace(addressComponent.streetNumber, '');

            mapClickCallBack(e.lnglat, address, byname);
        });
    }


    // 绑定地图点击事件
    const mapClick = (e) => {

        if (!beforeJudgeRef(true, false)) {
            return;
        }
        if (lockMapClick == true) {
            return
        } else {
            lockMapClick = true;
        }


        mapRemove(longMarkRef.current);
        //临时解决bug，多个标记，前一个未删除且按钮无法绑定事件
        if (document.getElementById('clickMark')) {
            document.getElementById('clickMark').parentNode.remove();
        }

        let address = '此处';
        if (appSetting.placesearch == true) {
            // 搜索附近标志物
            var PlaceSearchOptions = { //设置PlaceSearch属性
                city: "北京", //城市
                //types: "190000|180000|170000|050000",//|150000|120000
                pageSize: 10, //每页结果数,默认10
                pageIndex: 1, //请求页码，默认1
                extensions: "base" //返回信息详略，默认为base（基本信息）
            };
            var placeSearch = new AMap.PlaceSearch(PlaceSearchOptions); //构造PlaceSearch类
            placeSearch.searchNearBy('', e.lnglat, 10, function (status, result) {
                lockMapClick = false;
                if (status == "complete" && result.poiList?.pois?.length > 0) {
                    var poi = result.poiList.pois[0];
                    mapClickCallBack(e.lnglat, poi.address, poi.name);
                    // console.log(result)
                } else {
                    mapClickGeocoder(e);
                }
            });
        } else {

            mapClickGeocoder(e, address);

            // 逆地理编码
            // var geocoder = new AMap.Geocoder({
            //     city: "010", // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            // });
            // geocoder.getAddress(e.lnglat, function (status, result) {

            //     lockMapClick = false;

            //     let addressdeal = "";
            //     let addressComponent = "";
            //     let position = lngLatToString(lnglat);

            //     if (status === 'complete' && result.regeocode) {
            //         addressdeal = result.regeocode.formattedAddress.replace('北京市', '').replace('(建设中)', '');
            //         addressComponent = result.regeocode.addressComponent;
            //         if (addressdeal.length > 10) {
            //             address = addressComponent.district + addressComponent.township + addressComponent.street + addressComponent.streetNumber;
            //             //address = addressComponent.street + addressComponent.streetNumber;
            //         } else {
            //             address = addressdeal;
            //         }

            //     }

            //     const mark = new AMap.Marker({
            //         position: e.lnglat,
            //         icon: Icon,
            //         anchor: 'bottom-center',
            //         label: {
            //             content: `<div class="markInfo">${address}</div>
            //                      <div id="startButton" class="markButton blue">起</div>`
            //                 + `<div id="viaButton" class="markButton via">经</div>`
            //                 + `<div id="endButton" class="markButton red">终</div>`
            //                 + `<div id="starButton" class="markButton star">收</div>`
            //                 + `<div class='mark-close' id='clickMark'>X</div>`,
            //             offset: new AMap.Pixel(0, -3),
            //             direction: 'top',
            //         }
            //     });

            //     mark.setMap(map);
            //     longMarkRef.current = mark


            //     setTimeout(() => {
            //         document.getElementById("startButton").onclick = () => {
            //             setStartAndEnd(e.lnglat, 1, address)
            //             mapRemove(mark)
            //             //document.getElementById("txtStart").value = address;
            //         }

            //         document.getElementById("viaButton").onclick = () => {
            //             setVia(e.lnglat, address)
            //         }

            //         document.getElementById("endButton").onclick = () => {
            //             setStartAndEnd(e.lnglat, 2, address)
            //             mapRemove(mark)
            //             //document.getElementById("txtEnd").value = address;
            //         }

            //         document.getElementById("clickMark").onclick = () => {
            //             mapRemove(mark)
            //         }


            //         document.getElementById("starButton").onclick = () => {
            //             if (beforeJudgeRef(true)) {
            //                 const byname = addressdeal.replace(addressComponent.district, '')
            //                     .replace(addressComponent.township, '')
            //                     .replace(addressComponent.street, '')
            //                     .replace(addressComponent.streetNumber, '')
            //                     .replace(addressComponent.neighborhood, '')
            //                 axios.post('/api/addcollect', { userid: userRef.current.id, address: address, position: position, byname: (byname.trim() == "" ? address : byname) }).then(function (response) {
            //                     if (response.data == "code1") {
            //                         log("真的不能再多了")
            //                     } else {
            //                         message.success("收藏成功");
            //                         mapRemove(mark);
            //                         setStarTip(true);
            //                         setTimeout(() => {
            //                             setStarTip(false);
            //                         }, 2000);
            //                     }
            //                 }).catch(function (error) {
            //                     console.log("/addcamera" + error);
            //                     log("收藏地点失败");
            //                 })
            //             }
            //         }
            //     }, 10);
            // });
        }
    }
    // 调试定位
    const BrowserLocation = () => {
        try {
            var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };
            function success(pos) {
                var crd = pos.coords;
                //console.log("Your GPS current position is:" + crd.longitude + "," + crd.latitude);

                AMap.convertFrom([crd.longitude, crd.latitude], 'gps', function (status, result) {
                    if (result.info === 'ok') {
                        var lnglat = result.locations[0];
                        if (GaolocationRef.current == null) {
                            GaolocationRef.current = { position: lngLatToString(lnglat), address: "我的位置" }
                            setStartAndEnd(lnglat, 1, "我的位置");
                            map.setZoomAndCenter(16, lnglat, true);
                            GaolocationRealAddress(lnglat)
                        } else {
                            map.setZoomAndCenter(16, lnglat, true);
                            LocateCallBack(lnglat)
                        }
                    }
                });
            }
            function error(err) {
                console.warn("Your GPS ERROR(" + err.code + "): " + err.message);
            }
            navigator.geolocation.getCurrentPosition(success, error, options);
        } catch (error) {
            console.log("BrowserLocationError" + error.stack);
        }
    }
    const LocateCallBack = (lnglat) => {
        if (map != null && AMap != null) {

            if (locateRef.current != null) {
                map.remove(locateRef.current);
            }
            const mark = new AMap.Marker({
                position: lnglat,
                icon: new AMap.Icon({
                    // 图标尺寸
                    size: new AMap.Size(20, 20),
                    // 图标的取图地址
                    image: locate,
                    // 图标所用图片大小
                    imageSize: new AMap.Size(20, 20),

                }),
                anchor: 'bottom-center'
            });
            locateRef.current = mark;
            mark.setMap(map);
        }
    }
    // 微信定位
    const WXGetLocation = () => {
        wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
                const latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                const longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                const speed = res.speed; // 速度，以米/每秒计
                const accuracy = res.accuracy; // 位置精度
                const position = longitude + "," + latitude;
                console.log("Your VX current position is:" + position);
                const lnglat = stringToLngLat(position);
                if (GaolocationRef.current == null) {
                    GaolocationRef.current = { position: position, address: "我的位置" }
                    if (map != null && AMap != null) {
                        setStartAndEnd(lnglat, 1, "我的位置");
                        map.setZoomAndCenter(16, lnglat, true);
                        GaolocationRealAddress(lnglat)
                    }
                } else {
                    map.setZoomAndCenter(16, lnglat, true);
                    LocateCallBack(lnglat)
                }
            }
        })
    }

    // 安卓定位回调web显示
    window.AndroidCallJsGaolocation = (position) => {
        try {
            if (GaolocationRef.current == null) {
                GaolocationRef.current = { position: position, address: "我的位置" }
                if (map != null && AMap != null) {
                    const lnglat = stringToLngLat(position);
                    if (lnglat != null) {
                        setStartAndEnd(lnglat, 1, "我的位置");
                        map.setZoomAndCenter(16, lnglat, true);
                        GaolocationRealAddress(lnglat)
                    }
                }
            } else {
                const lnglat = stringToLngLat(position);
                if (lnglat != null) {
                    map.setZoomAndCenter(16, lnglat, true);
                    LocateCallBack(lnglat)
                }
            }
            return 'js定位成功返回' + position
        } catch (e) {
            emailfromjs("AndroidCallJsGaolocation:" + e.stack, "position:" + position)
        }
    }

    // android 高德定位回调
    const GaolocationRealAddress = (lnglat) => {
        var geocoder = new AMap.Geocoder({
            city: "010", // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        });
        geocoder.getAddress(lnglat, function (status, result) {
            let addressdeal = "";
            let addressComponent = "";
            let address = "";
            if (status === 'complete' && result.regeocode) {
                addressdeal = result.regeocode.formattedAddress.replace('北京市', '').replace('(建设中)', '');
                addressComponent = result.regeocode.addressComponent;
                if (addressdeal.length > 20) {
                    address = addressComponent.district + addressComponent.township + addressComponent.street + addressComponent.streetNumber;
                } else {
                    address = addressdeal;
                }
                GaolocationRef.current.address = address;
            }
        })
    }

    // 获取用户信息
    const getUser = () => {
        const localuser = JSON.parse(localStorage.getItem("user"));
        //刷新用户信息
        axios.post('/api/getuser', { id: localuser.id }).then(function (response) {
            const userinfo = response.data;
            if (userinfo == "") {
                localStorage.removeItem("user");
                setUser(null);
            } else {
                localStorage.setItem("user", JSON.stringify(userinfo));
                setUser(userinfo);
            }
        }).catch(function (e) {
            emailfromjs(e.stack, "getUser用户登录" + " " + localStorage.getItem("user"))
        })
    }

    // 获取（非会员/非赞赏会员）今日剩余次数
    const getRemain = () => {
        if (user != null) {
            axios.post('/api/todayremain', {
                userid: user.id
            }).then(function (response) {
                setRemain(totalRemain - _.toFinite(response.data));
            }).catch(function (error) {
                emailfromjs(error.stack, '/api/todayremain')
            })
        }
    }

    // 获取用户是否是赞赏会员
    const getUserIsPayVip = () => {
        axios.post('/api/userispayvip', {
            userid: user.id
        }).then(function (response) {
            if (response.data.length > 0) {
                setPayVip(true);
            } else {
                setPayVip(false);
                setTotalRemain(20);
            }
        }).catch(function (error) {
            emailfromjs(error.stack, '/api/userispayvip')
        })
    }

    // 获取用户排除的摄像头
    const getUserExcludeCamera = () => {
        axios.post('/api/userexcludecamera', {
            userid: user.id
        }).then(function (response) {
            setUserExcludeCamera(response.data);
            userExcludeCameraRef.current = response.data;
        }).catch(function (error) {
            emailfromjs(error.stack, '/api/userexcludecamera')
        })
    }

    //删除指定标记
    const mapRemove = (mark) => {
        if (mark != null && map != null) {
            map.remove(mark);
        }
    }

    const loading = (state) => {
        // 自动六环算路开启，并且没循环完的时候，继续循环
        if (state == false && sixDoorAuto == true && autoOverRef.current == true) {
            goBefore()
            return
        }
        document.getElementById("loading").style.display = (state || autoOverRef.current) ? "flex" : "none";
    }

    // 初始化文本框功能
    const loadMap = () => {
        //会员专属功能2，地址自动提示
        //黑名单不准使用，针对白嫖上瘾的用户
        if (user && (vip || appSetting.allownotvipsearch == true) && user?.black != true) {
            initInput('txtStart');
            initInput('txtEnd');
            initInput('txtVia');
        }
    }

    // 输出结果
    const log = (msg, state = 0, clear = false) => {
        if (clear) {
            document.getElementById("drivingResult").innerHTML = "";
        }
        document.getElementById("drivingResult").innerHTML = `${document.getElementById("drivingResult").innerHTML}<div class='log-text' style="color:${state === 1 ? 'green' : 'red'}">${msg}</div>`;
    }
    const emailfromjs = (error, subject) => {
        axios.post('/api/emailfromjs', { error: error, subject: 'js报错' + subject })
    }

    // 标记所有摄像头 
    const createAllCamareMarkerAndPolygon = () => {
        const datas = [];
        const styles = [{
            url: camPot,
            anchor: 'bottom-center',
            size: new AMap.Size(21, 27),
            zIndex: 1,
        }, {
            url: camTem,
            anchor: 'bottom-center',
            size: new AMap.Size(21, 27),
            zIndex: 1,
        }, {
            url: camNew,
            anchor: 'bottom-center',
            size: new AMap.Size(21, 27),
            zIndex: 1,
        }, {
            url: camHigh,
            anchor: 'bottom-center',
            size: new AMap.Size(21, 27),
            zIndex: 1
        }]

        let selectCamera = [];
        if (showCamera.includes("all")) {
            selectCamera = camera;
        } else {
            if (showCamera.includes("new")) {
                selectCamera = selectCamera.concat(camera.filter(c => c.checktime === camera[0].checktime));
            }
            if (showCamera.includes("temp")) {
                selectCamera = selectCamera.concat(camera.filter(c => c.temp === true));
            }
            if (showCamera.includes("high")) {
                selectCamera = selectCamera.concat(camera.filter(c => c.high === true));
            }
        }

        const findex = (c) => {
            if (c.temp == true) {
                return 1;
            } else if (c.high == true) {
                return 3
            } else if (c.checktime == camera[0].checktime) {
                return 2;
            } else {
                return 0;
            }
        }

        for (let index = 0; index < selectCamera.length; index++) {
            const c = selectCamera[index];
            datas.push({
                lnglat: c.position,
                name: c.name,
                id: c.id,
                photo: c.photo,
                style: findex(c) //该数据的取值为样式数组对应的对象索引
            });
        }

        // 海量标记摄像头
        const _mass = new AMap.MassMarks(datas, {
            style: styles
        })


        _mass.on('click', (e) => {
            let marker = camareMarkRef.current;
            if (marker === null || e.data.lnglat !== marker._opts.position) {
                if (marker !== null) {
                    mapRemove(marker)
                }
                const cid = "camare" + e.data.id;
                marker = new AMap.Text({
                    map: map,
                    position: e.data.lnglat,
                    anchor: 'top-center',
                    offset: [0, -60],
                    text: e.data.name,
                    style: {
                        // "font-size": "14px",
                        "padding": "5px 10px",
                        "border-radius": "5px",
                        "box-shadow": "0px 0px 5px rgba(10, 10, 10, .5)",
                        "font-weight": "400"
                    },
                    extData: { id: e.data.id },
                    zIndex: 2
                });
                mapRemove(camareMarkRef.current)
                camareMarkRef.current = marker;

                const imageSvg = '<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M1024 826.507636a83.223273 83.223273 0 0 1-83.037091 81.128728H82.990545A83.176727 83.176727 0 0 1 0 826.507636V197.538909A83.223273 83.223273 0 0 1 82.990545 116.363636h857.972364A83.176727 83.176727 0 0 1 1024 197.538909v628.968727zM82.990545 177.245091a13.963636 13.963636 0 0 0-13.963636 6.749091 23.272727 23.272727 0 0 0-6.935273 13.544727V833.163636a14.708364 14.708364 0 0 0 13.963637 13.498182h857.925818a14.708364 14.708364 0 0 0 13.963636-13.498182V197.538909a14.708364 14.708364 0 0 0-13.963636-13.544727zM235.240727 447.767273a99.234909 99.234909 0 0 1-96.861091-101.469091 105.192727 105.192727 0 0 1 103.749819-101.422546 107.054545 107.054545 0 0 1 69.21309 27.042909 95.650909 95.650909 0 0 1 27.648 67.630546A102.4 102.4 0 0 1 235.240727 447.767273z m650.379637 284.811636H138.379636V677.701818l166.027637-169.099636 83.037091 81.175273 276.759272-263.773091 221.416728 216.436363v190.138182z m0 0" ></path></svg>';



                const markdivs = document.getElementsByClassName("amap-marker")
                for (let mi = 0; mi < markdivs.length; mi++) {
                    const markdiv = markdivs[mi];

                    const noSelectSvg = '<svg viewBox="64 64 896 896" focusable="false" data-icon="stop" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"></path></svg>';
                    const selectSvg = '<svg viewBox="64 64 896 896" focusable="false" data-icon="stop" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z" fill="#1677ff"></path><path d="M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z" fill="#e6f4ff"></path></svg>';


                    if (markdiv.textContent == e.data.name) {


                        let hasExclud = userExcludeCameraRef.current.findIndex(fc => fc.cameraid == e.data.id) > -1
                        const excludeClick = (eo) => {
                            hasExclud = userExcludeCameraRef.current.findIndex(fc => fc.cameraid == e.data.id) > -1
                            eo.stopPropagation()
                            eo.preventDefault()

                            //addexcludeCamera
                            if (beforeJudgeRef(true, false)) {
                                axios.post("/api/" + (hasExclud ? "deleteexcludecamera" : "addexcludecamera"), {
                                    userid: user.id,
                                    cameraid: e.data.id
                                }).then(res => {
                                    getUserExcludeCamera()
                                    markdiv.childNodes[0].innerHTML = (e.data.photo == null ? "" : '<span id="' + cid + 'preview" style="color:#0072ff;margin-right:5px;font-size:14px;position:relative;top:2px">' + imageSvg + '</span>') + e.data.name + '<span id="' + cid + 'exclude" style="margin:0px 5px;font-size:14px;position:relative;top:2px">' + (hasExclud ? noSelectSvg : selectSvg) + '</span>' + "<div class='mark-close' id='" + cid + "close'>X</div>";
                                    document.getElementById(cid + "exclude").onclick = excludeClick;

                                    document.getElementById(cid + "close").onclick = () => {
                                        mapRemove(marker);
                                        camareMarkRef.current = null
                                    }

                                    if (e.data.photo != null) {
                                        document.getElementById(cid + "preview").onclick = () => {
                                            setCamImageUrl(e.data.photo)
                                            setCamImageOpen(true)
                                        }
                                    }
                                })
                            }
                        }

                        markdiv.id = cid;
                        markdiv.childNodes[0].innerHTML = (e.data.photo == null ? "" : '<span id="' + cid + 'preview" style="color:#0072ff;margin-right:5px;font-size:14px;position:relative;top:2px">' + imageSvg + '</span>') + e.data.name + '<div id="' + cid + 'exclude" style="display:inline;margin-left:10px;margin-right:5px;font-size:14px;position:relative;top:2px">' + (hasExclud ? selectSvg : noSelectSvg) + '</div>' + "<div class='mark-close' id='" + cid + "close'>X</div>";
                        document.getElementById(cid + "exclude").onclick = excludeClick;

                        document.getElementById(cid + "close").onclick = () => {
                            mapRemove(marker);
                            camareMarkRef.current = null
                        }

                        if (e.data.photo != null) {
                            document.getElementById(cid + "preview").onclick = () => {
                                setCamImageUrl(e.data.photo)
                                setCamImageOpen(true)
                            }
                        }
                    }
                }
            }
        });
        _mass.setMap(map)

        setMass(_mass);
    }

    useEffect(() => {

        if (mass != true) {
            mass.clear();
            mapRemove(camareMarkRef.current);
        }
        if (showCamera.length > 0) {
            createAllCamareMarkerAndPolygon();
        }

    }, [showCamera])

    // 创建单个摄像头避让区域
    const createCamarePolygon = (c) => {
        let cp = new AMap.LngLat(c.position[0], c.position[1]);
        let double = 1;
        if (c.name.indexOf("双向") > -1 || c.name.indexOf("待确认") > -1) {
            double = 2;
        } else {
            double = 1
        }
        double = c.double ?? double

        return [
            new AMap.LngLat(cp.lng - toleranceX * double, cp.lat + toleranceY * double),
            new AMap.LngLat(cp.lng + toleranceX * double, cp.lat + toleranceY * double),
            new AMap.LngLat(cp.lng + toleranceX * double, cp.lat - toleranceY * double),
            new AMap.LngLat(cp.lng - toleranceX * double, cp.lat - toleranceY * double)
        ]
    }

    // 加载文本框
    const initInput = (inputId) => {
        let autoOptions = { input: inputId, city: "北京" }
        let auto = new AMap.AutoComplete(autoOptions);
        AMap.Event.addListener(auto, 'error', () => {
            document.getElementById(inputId).setAttribute("lnglat", "");
        })

        const select = (e) => {
            //对选中位置对焦放大
            let searchCenter = new AMap.LngLat(e.poi.location.lng, e.poi.location.lat);
            map.setZoomAndCenter(18, searchCenter, false, 500);
            if (inputId !== "txtVia") {
                setStartAndEnd(searchCenter, inputId === "txtStart" ? 1 : 2)
            } else {
                setVia(searchCenter, e.poi.name)
            }
        }
        auto.off("select", select);
        auto.on("select", select);//注册监听，当选中某条记录时会触发
    }

    const setVia = (lngLat, address) => {
        mapRemove(polylineRef.current);
        if (lngLat != null && address != null) {
            const vm = _.cloneDeep(viaRef.current);
            if (viaRef.current.length == 0) {
                vm.push({ position: lngLat, text: address });
            } else {
                vm[0] = { position: lngLat, text: address };
            }
            viaRef.current = vm;
            setRefresh(new Date().getTime())

            // 创建一个 Icon
            let Icon = new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: dirMark,
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-53, -3)
            });

            //只标记选中的那个
            const mark = new AMap.Marker({
                position: lngLat,
                icon: Icon,
                map: map,
                offset: new AMap.Pixel(-13, -30)
            });

            mapRemove(longMarkRef.current)
            mapRemove(viaMarkRef.current)
            viaMarkRef.current = mark;
        } else {
            viaRef.current = [];
            mapRemove(viaMarkRef.current)
            viaMarkRef.current = [];
            setRefresh(new Date().getTime());
        }
    }
    //1起点，2终点
    const setStartAndEnd = (lngLat, type, address = "") => {
        //修改起、终点需要重新算路
        setNaviVisable(false);
        setStarVisable(false);
        mapRemove(polylineRef.current);
        mapRemove(routeViaMarkRef.current)

        routeViaMarkRef.current = []

        if (sixDoorAuto) {
            clearVia(0)
        }


        //坐标写input上
        document.getElementById(type === 1 ? "txtStart" : "txtEnd").setAttribute("lnglat", [lngLat.lng, lngLat.lat]);

        if (address != "") {
            document.getElementById(type === 1 ? "txtStart" : "txtEnd").value = address;
        }

        let Icon = new AMap.Icon({
            size: new AMap.Size(25, 34),
            image: dirMark,
            imageSize: new AMap.Size(135, 40),
            imageOffset: type === 1 ? new AMap.Pixel(-9, -3) : new AMap.Pixel(-95, -3)
        });

        //只标记选中的那个
        const mark = new AMap.Marker({
            position: lngLat,
            icon: Icon,
            map: map,
            offset: new AMap.Pixel(-13, -30)
        });
        if (type === 1) {
            mapRemove(startMarkRef.current)
            startMarkRef.current = mark;
        } else {
            mapRemove(endMarkRef.current)
            endMarkRef.current = mark;
        }

    }

    //交换起终点
    const exchange = () => {

        setNaviVisable(false)
        setStarVisable(false)

        let tempText = document.getElementById('txtStart').value;
        let tempPosition = document.getElementById('txtStart').getAttribute("lnglat");

        document.getElementById('txtStart').value = document.getElementById('txtEnd').value;
        document.getElementById('txtStart').setAttribute("lnglat", document.getElementById('txtEnd').getAttribute("lnglat"));

        document.getElementById('txtEnd').value = tempText;
        document.getElementById('txtEnd').setAttribute("lnglat", tempPosition);


        const temp = startMarkRef.current
        startMarkRef.current = endMarkRef.current
        endMarkRef.current = temp

        autoRoutesRef.current = []
        mapRemove(polylineRef.current)
        mapRemove(routeViaMarkRef.current)

        //如果途经点是六环口之一，需要清除，因为入口出口会反，导致大量计算，设置程序崩溃闪退 （后面再加这个逻辑吧）
        if (viaRef.current.length > 0) {
            if (sixdoor.findIndex(fi => fi.position == lngLatToString(viaRef.current[0].position))) {
                clearVia(0);
            }
        }
    }

    const isBeiJingAll = (laglat) => {
        return AMap.GeometryUtil.isPointInPolygons(laglat, beijing);
    }

    // 判断点是否在北京（六环内、通州、延庆、顺义）
    const isBeiJingInside = (laglat) => {
        return AMap.GeometryUtil.isPointInPolygons(laglat, [sixPath, tongZhou, yanQing, shunYi]);
    }

    const stringToLngLat = (str) => {
        let lnglat = str.split(",");
        return new AMap.LngLat(lnglat[0], lnglat[1]);
    }

    const lngLatToString = (lnglat) => {
        return lnglat.lng + "," + lnglat.lat;
    }

    // 所有要躲避的摄像头区域（tolerance是经纬度误差 0.00005,形成的多边形）
    let totalAvoidCameraPolygons = [];
    let totalAvoidCameraInfo = []
    // 所有躲避不开的摄像头信息
    let preDrivingCamera = [];
    let totalMarker = [];

    // 清除记录
    const clear = () => {
        mapRemove(totalMarker);
        document.getElementById("drivingResult").innerHTML = "";
        totalAvoidCameraPolygons = [];
        totalAvoidCameraInfo = []
        preDrivingCamera = [];
        totalMarker = [];

        // mapRemove(polylineRef.current);
        mapRemove(camareMarkRef.current);
        camareMarkRef.current = null
    }

    const clearVia = (vi) => {
        const vm = _.cloneDeep(viaRef.current);
        vm.splice(vi, 1);
        viaRef.current = vm;
        mapRemove(viaMarkRef.current)
        setRefresh(new Date().getTime())
    }


    const apiCount = useRef([]);
    const timeS = useRef(null);
    //QPS
    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const restapi = (startLnglatStr, endLnglatStr, avoidpolygons, waypoints, strategy, callback) => {

        let url = `https://restapi.amap.com/v3/direction/driving?origin=${startLnglatStr}&destination=${endLnglatStr}&extensions=all&output=json&key=${appSetting.webkey}&strategy=${strategy}`;

        if (avoidpolygons?.length > 0) {
            const totalStringArray = avoidpolygons.map(c => {
                const cs = c.map(cc => {
                    return lngLatToString(cc)
                })
                return cs.join(';');
            });
            url += '&avoidpolygons=' + totalStringArray.join('|');
        }
        if (waypoints?.length > 0) {
            url += '&waypoints=' + waypoints.join(';');
        }

        let sleepTime = 0;
        if (apiCount.current.length >= 3) {
            const diff = apiCount.current[0].diff(apiCount.current[2]);
            if (diff <= appSetting.qps) {
                //sleep  清空，应对qps，尽可能提高效率
                sleepTime = appSetting.qps - diff;
            }
        }

        apiCount.current.unshift(dayjs());

        sleep(sleepTime).then(() => {
            axios.post(url).then(function (response) {
                callback(response)
            }).catch(function (error) {
                // loading(false)
                // log("请求错误")
                console.log(error)
                callback({ data: { status: 0, info: "restapi_catch:" + JSON.stringify(error) } })
            })
        })
    }

    const goBefore = () => {
        if (!beforeJudge())
            return false

        if ((!vip || !payVip) && remain <= 0) {
            setVipInfoOpen(true)
            return
        }
        mapRemove(polylineRef.current);

        const startValue = document.getElementById("txtStart").value.trim();
        const endValue = document.getElementById("txtEnd").value.trim();

        if (startValue == "") {
            document.getElementById("txtStart").setAttribute("lnglat", "")
        }
        if (endValue == "") {
            document.getElementById("txtEnd").setAttribute("lnglat", "")
        }

        let startLnglatStr = document.getElementById("txtStart").getAttribute("lnglat");
        let endLnglatStr = document.getElementById("txtEnd").getAttribute("lnglat");

        if (startLnglatStr && endLnglatStr) {
            setStartAndEnd(stringToLngLat(startLnglatStr), 1)
            setStartAndEnd(stringToLngLat(endLnglatStr), 2)

            go(startLnglatStr, endLnglatStr)
        } else {

            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
            });

            if (!startLnglatStr) {
                if (startValue === '') {
                    log("请输入起点！");
                    mapRemove(startMarkRef.current)
                    startMarkRef.current = null
                    document.getElementById("txtStart").focus();
                    return false
                } else {

                    //解决地理编码接口回调失败问题
                    const tiout = setTimeout(() => {
                        log("未找到起点: " + startValue + "，建议点击地图设置起点");
                    }, 1000);

                    geocoder.getLocation(startValue, function (status, result) {
                        clearTimeout(tiout);
                        if (status === "complete" && result.info === "OK" && result.geocodes.length) {
                            startLnglatStr = result.geocodes[0].location.toString();

                            //覆盖
                            setStartAndEnd(result.geocodes[0].location, 1)

                            if (endLnglatStr) {
                                go(startLnglatStr, endLnglatStr)
                            }
                        } else {
                            log("未找到起点: " + startValue + "，建议点击地图设置起点");
                        }
                    });
                }
            }


            if (!endLnglatStr) {
                if (endValue === '') {
                    log("请输入终点！");
                    mapRemove(endMarkRef.current)
                    endMarkRef.current = null
                    document.getElementById("txtEnd").focus();
                    return false
                } else {
                    //解决地理编码接口回调失败问题
                    const tiout = setTimeout(() => {
                        log("未找到终点: " + endValue + "，建议点击地图设置终点");
                    }, 1000);

                    geocoder.getLocation(endValue, function (status, result) {
                        clearTimeout(tiout);
                        if (status === "complete" && result.info === "OK" && result.geocodes.length) {
                            endLnglatStr = result.geocodes[0].location.toString();

                            //覆盖                            
                            setStartAndEnd(result.geocodes[0].location, 2)

                            if (startLnglatStr) {
                                go(startLnglatStr, endLnglatStr)
                            }
                        } else {
                            log("未找到终点: " + endValue + "，建议点击地图设置终点");
                        }
                    });
                }
            }
        }
    }

    const go = (startLnglatStr, endLnglatStr, strategy = 10) => {

        if (!startLnglatStr || !endLnglatStr) {
            log("请输入起点和终点！");
            return
        }

        loading(true);

        // 如果开启自动六环，设置标志位
        if (sixDoorAuto) {
            autoOverRef.current = true;

            let allSixDoor = [];
            if (sixDoorMode == 1 || sixDoorMode == 2) {
                //最快、平衡
                allSixDoor = startCloserSixDoor;
            } else {
                //最优
                allSixDoor = _.orderBy(startCloserSixDoor.concat(endCloserSixDoor), ['distance'], ['asc']);
            }

            if (autoIndexRef.current == null) {
                autoIndexRef.current = 0;
            } else {

                if (autoIndexRef.current == allSixDoor.length - 1) {
                    autoOverRef.current = false;

                    console.log(`(${(sixDoorMode == 2 ? "平衡" : "最优")})耗时${((performance.now() - timeS.current) / 1000).toFixed(1)}秒`);
                    //结束后筛选成功路线
                    if (autoRoutesRef.current.length > 0) {
                        //清掉
                        document.getElementById("drivingResult").innerHTML = "";
                        //展示路线列表
                        setAutoRoutesShow(true);
                        //不要最后的途经点
                        clearVia(0);
                    }
                    else {
                        log("规划失败：无法避开或摄像头太多，请尝试分段规划！");
                    }
                    loading(false);
                    return
                }
                autoIndexRef.current = autoIndexRef.current + 1;
            }

            const getv = allSixDoor[autoIndexRef.current]
            setVia(stringToLngLat(getv.position), getv.name)
        }


        setNaviParam(null)
        setNaviVisable(false)

        setStarVisable(false);

        //web服务算路
        //判断规划是否进入死循环（最后一轮和倒数第二轮最后一个摄像头是否相同）
        const goDrivingIsOver = () => {

            if (totalAvoidCameraPolygons.length > 32) {
                return true
            } else {

                let lastRoundLastCamera = preDrivingCamera[preDrivingCamera.length - 1]
                lastRoundLastCamera = lastRoundLastCamera.cameras[lastRoundLastCamera.cameras.length - 1];

                let lastRoundBeforeLastCamera = preDrivingCamera[(preDrivingCamera.length - 2)]
                lastRoundBeforeLastCamera = lastRoundBeforeLastCamera.cameras[lastRoundBeforeLastCamera.cameras.length - 1];

                return lastRoundLastCamera.name === lastRoundBeforeLastCamera.name;
            }
        }

        //判定 是否节假日、是否高峰期，决定是否避开某些摄像头（顺义区六环外高峰期）       
        let isHigh = false;
        const now = dayjs();
        //如果节假日列表不包含当前时间，就是工作日，且在高峰期，就需要避开高峰期。
        if (!nohighday.includes(now.format("YYYY-MM-DD")) && ((now.hour() >= 7 && now.hour() <= 9) || (now.hour() >= 17 && now.hour() <= 20))) {
            isHigh = true;
        }

        //递归直到规划路线上没有摄像头
        const goDriving = (round) => {
            // console.log("round:" + round)
            //途经点
            const waypoints = [];
            viaRef.current.map(v => {
                waypoints.push(lngLatToString(v.position))
            })
            restapi(startLnglatStr, endLnglatStr, totalAvoidCameraPolygons, waypoints, strategy, (response) => {
                const result = response.data;
                if (result.status == 1) {

                    //途径摄像头个数
                    let wayCameraPolygons = [];
                    let wayCameraInfo = [];

                    const steps = result.route.paths[0].steps;

                    for (let si = 0; si < steps.length; si++) {

                        let step = steps[si];

                        let polyline = step.polyline.split(';');
                        const polylineArray = polyline.map(p => stringToLngLat(p))

                        //如果每段step有一头在北京
                        if (isBeiJingInside(stringToLngLat(polyline[0])) || isBeiJingInside(stringToLngLat(polyline[polyline.length - 1]))) {

                            //找到每段step途径的
                            let wayDistrictsCamera = [];

                            step.cities.map(city => {
                                if (city.adcode == "110100") {
                                    city.districts.map(cityDistrict => {
                                        //wayDistrictsCamera = wayDistrictsCamera.concat(filterCamares.filter(cf => cf.adcode == cityDistrict.adcode && cf.temp != true));
                                        // wayDistrictsCamera = wayDistrictsCamera.concat(validCamera[cityDistrict.adcode]);
                                        wayDistrictsCamera = wayDistrictsCamera.concat(isHigh ? validCamera[cityDistrict.adcode] : validCamera[cityDistrict.adcode].filter(c => c.high != true));
                                    })
                                }
                            })

                            /** 已优化到最佳状态，封档，无需再调整 2025-3-29  */

                            // 整条路径是否包含摄像头 （经测试，非直线路径也生效）
                            // doesLineRingIntersect （路径 lngla 数组，单摄像头区域 lnglat 数组，是否碰撞）
                            wayDistrictsCamera.map(c => {

                                if (AMap.GeometryUtil.doesLineRingIntersect(polylineArray, c.wayPolygon)) {
                                    // 是否同向变量
                                    let sameOrientation = false

                                    // // 如果是双向，就不用判断方向了，单向才需要判断
                                    // if (c.double == null) {
                                    //     //解决斜路问题，有时step.orientation只返回一个方向，与添加摄像头时方向判断有异，所以/备用一个方向
                                    //     if (c.orientation?.indexOf("/") > -1) {
                                    //         c.orientation.split("/").map(o => {
                                    //             if (!sameOrientation) {
                                    //                 sameOrientation = step.orientation.indexOf(o) > -1
                                    //             }
                                    //         })
                                    //     } else {
                                    //         sameOrientation = step.orientation.indexOf(c.orientation) > -1
                                    //     }
                                    // }
                                    // // 双向不能走、同向不能走
                                    // if (c.double != null || sameOrientation) {
                                    //     wayCameraPolygons.push(c.wayPolygon);
                                    //     wayCameraInfo.push({ name: c.name, position: c.cp });
                                    // }

                                    if (step.orientation?.length > 0) {
                                        // 方向被摄像头方向包含，不能过
                                        step.orientation.split("").map(so => {
                                            if (c.orientation.indexOf(so) > -1) {
                                                sameOrientation = true;
                                            }
                                        })
                                    } else {
                                        // 方向异常不能过
                                        sameOrientation = true;
                                    }


                                    if (sameOrientation) {
                                        wayCameraPolygons.push(c.wayPolygon);
                                        wayCameraInfo.push({ name: c.name, position: c.cp });
                                    }

                                    //#region
                                    // if (c.orientation == null) {
                                    //     // 方向不明，视为同向，必须躲避，
                                    //     sameOrientation = true;
                                    // } else {

                                    //     // 如果是多个方向，挨个判断是否方向重合，有一个重合，视为同向（无论单向双向，2025-7-25 双向确认方向的也标注 orientation 字段(未实施，四个方向的摄像头少，可使用自定义不拍功能解决，尽量不动稳定的逻辑)）
                                    //     if (c.orientation.indexOf("/") > -1) {
                                    //         c.orientation.split("/").map(o => {
                                    //             if (!sameOrientation) {
                                    //                 sameOrientation = step.orientation.indexOf(o) > -1
                                    //             }
                                    //         })
                                    //     } else {
                                    //         sameOrientation = step.orientation.indexOf(c.orientation) > -1
                                    //     }
                                    // }
                                    // if (sameOrientation) {
                                    //     wayCameraPolygons.push(c.wayPolygon);
                                    //     wayCameraInfo.push({ name: c.name, position: c.cp });
                                    // }
                                    //#endregion
                                }
                            })



                        } else {
                            continue
                        }
                    }

                    preDrivingCamera.push({ round: round, cameras: wayCameraInfo });

                    if (wayCameraPolygons.length > 0) {

                        if (preDrivingCamera.length > 1 && goDrivingIsOver()) {
                            loading(false);
                            if (autoOverRef.current == false && autoRoutesRef.current.length == 0) {
                                log('规划失败：无法避开或摄像头太多，请尝试分段规划！');
                                console.log(`失败耗时${((performance.now() - timeS.current) / 1000).toFixed(1)}秒`);
                            }
                        } else {
                            // 上次改完核心逻辑后，每轮循环，都把摄像头加入到总集合中，就会有重复，复杂路线就降低了成功率，要去重，否则会很快到达 32个，就会判断没路
                            // wayCameraPolygons.map(wc => {
                            //     let have = false;
                            //     for (let tacp = 0; tacp < totalAvoidCameraPolygons.length; tacp++) {
                            //         if (JSON.stringify(totalAvoidCameraPolygons[tacp]) == JSON.stringify(wc)) {
                            //             have = true;
                            //             break;
                            //         }
                            //     }
                            //     if (have == false) {
                            //         totalAvoidCameraPolygons.push(wc);
                            //     }
                            // })

                            wayCameraInfo.map((wci, wcindex) => {
                                if (totalAvoidCameraInfo.findIndex(tf => tf.name == wci.name) == -1) {
                                    totalAvoidCameraInfo.push(wci);
                                    totalAvoidCameraPolygons.push(wayCameraPolygons[wcindex])
                                }
                            })

                            //totalAvoidCameraPolygons = totalAvoidCameraPolygons.concat(wayCameraPolygons);
                            goDriving(round + 1);
                        }
                    } else {
                        goSuccess(result, startLnglatStr, endLnglatStr, strategy)
                    }
                } else {

                    // 可能是qps没控制好，或者请求实体太大了
                    // 已知 info 可能是
                    // 1、restapi_catch (Network Error 网络异常) 
                    // 2、CUQPS_HAS_EXCEEDED_THE_LIMIT (infocode":"10021") 超限返回

                    if (restapiErrorRef.current == false) {
                        //第一次失败给个机会，不管因为啥
                        restapiErrorRef.current = true;

                        setTimeout(() => {
                            goDriving(round)
                        }, appSetting.qps);

                    } else {

                        if (result?.info.indexOf("restapi_catch") > -1) {

                            // 第二次还是异常，就结束本轮
                            // autoOverRef.current = false;
                            loading(false);
                            log('规划失败：无法避开或摄像头太多，请尝试分段规划！');
                            //console.log('可能是qps没控制好，或者请求实体太大了');
                            // emailfromjs(JSON.stringify(response), "restapi 返回状态不是1");

                            restapiErrorRef.current = false

                        } else if (result?.info == "CUQPS_HAS_EXCEEDED_THE_LIMIT" || result?.infocode == "10021") {

                            // 明确是QPS超限问题的，每隔1s重试一次。

                            setTimeout(() => {
                                goDriving(round)
                            }, appSetting.qps);
                        }
                    }
                }
            })
        }

        //插入规划记录
        axios.post('/api/addrecord', {
            userid: user.id,
            startname: (document.getElementById('txtStart').value == "我的位置" ? GaolocationRef.current.address : document.getElementById('txtStart').value),
            startposition: startLnglatStr,
            endname: (document.getElementById('txtEnd').value == "我的位置" ? GaolocationRef.current.address : document.getElementById('txtEnd').value),
            endposition: endLnglatStr,
            sixauto: sixDoorAuto,
            sixmode: sixDoorAuto ? sixDoorMode : null,
            vianame: viaRef.current.length > 0 ? viaRef.current[0].text : null,
            viaposition: viaRef.current.length > 0 ? lngLatToString(viaRef.current[0].position) : null
        }).then(function (response) {
            if (!vip || !payVip) {
                //减次数
                setRemain(re => re - 1);
            }
        }).catch(function (error) {
            emailfromjs(error.stack, '/api/addrecord')
        })

        //开始规划
        if ((vip && payVip) || remain > 0) {
            goDriving(1);
        }
    }

    const routeViaMarkShow = (tempWaysCenter) => {

        // 有歧义，暂不显示 2025-7-10 (测试时显示)
        if (["localhost", "test.wintersir.com"].includes(window.location.hostname)) {

            //（后面优化显示地址 直接变成 "公众号 提示途经点" 功能，先return）

            tempWaysCenter.map((twc, twci) => {
                const twcmark = new AMap.Marker({
                    position: stringToLngLat(twc),
                    icon: new AMap.Icon({
                        // 图标尺寸
                        size: new AMap.Size(20, 29),
                        // 图标的取图地址
                        image: markerRed,
                        // 图标所用图片大小
                        imageSize: new AMap.Size(20, 29),
                    }),
                    anchor: 'bottom-center',
                    label: {
                        content: `途径` + (twci + 1),
                        offset: new AMap.Pixel(0, -3),
                        direction: 'top',
                    }
                });

                twcmark.setMap(map);
                routeViaMarkRef.current.push(twcmark)
            })
        }
    }


    const goSuccess = (result, startLnglatStr, endLnglatStr, strategy) => {
        //路线规划成功
        const steps = result.route.paths[0].steps;
        const duration = result.route.paths[0].duration;
        const distance = result.route.paths[0].distance;

        let startLnglat = startLnglatStr.split(',');
        let endLnglat = endLnglatStr.split(',');

        if (autoOverRef.current) {

            autoRoutesRef.current.push({ result, startLnglatStr, endLnglatStr, strategy, duration, distance, via: viaRef.current[0] })
            //最快模式，规划成功关闭六环自动算路
            if (sixDoorMode == 1) {
                autoOverRef.current = false;
            } else {
                //自动六环规划，成功后继续循环，直到最后，再筛选最优路线
                loading(false);
                return
            }
        }


        loading(false);

        //console.log(`(${(sixDoorAuto && sixDoorMode == 1) ? "最快" : "非自动"})耗时${((performance.now() - timeS.current) / 1000).toFixed(1)}秒`);


        const needTime = formatSeconds(duration);
        const needDistance = (distance / 1000).toFixed(2);
        log(`规划成功：${needTime} · ${needDistance}公里`, 1)

        //渲染
        const pathLine = [];
        steps.map(s => {
            s.polyline.split(';').map(ss => {
                const sss = ss.split(',');
                pathLine.push(new AMap.LngLat(sss[0], sss[1]))
            })
        })

        var polyline = new AMap.Polyline({
            path: pathLine,
            lineJoin: 'round',
            showDir: true,
            strokeColor: "#1bac2e",  //线颜色
            strokeOpacity: 1,     //线透明度
            strokeWeight: 6,      //线宽
            strokeStyle: "solid"  //线样式
        })

        polylineRef.current = polyline;

        map.add(polyline);
        //如果展示了摄像头，先隐藏，再显示，解决缩放问题。
        const sc = _.cloneDeep(showCamera);
        setShowCamera([]);
        setTimeout(() => {
            map.setFitView(undefined, undefined, [270, 60, 30, 50]);
            setShowCamera(sc);
        }, 10);


        //手机、网页都可收藏路线
        setStarVisable(true);

        setNaviVisable(true);

        //组织调用android/ios端导航所需参数，算路用首点当途经点，规划用中间点当途经点，提升精度
        let paramStr = ""
        let ways = []; // 每段路的第一个坐标点
        let waysCenter = []; // 每段路的中间坐标点
        let waysLast = []  // 每段路的最后一个坐标点
        steps.slice(1).map(s => {
            //用头尾做途经点会不准确，用中间
            const scount = s.polyline.split(';');

            //六环边上会有问题，再想办法优化吧，否则会消耗路径规划算力 2025-4-7 23:22:10
            //if (isBeiJingInside(stringToLngLat(scount[0])) || isBeiJingInside(stringToLngLat(_.last(scount)))) {
            ways.push(scount[0]);
            waysCenter.push(_.nth(scount, scount.length <= 2 ? 0 : scount.length / 2));
            waysLast.push(_.last(scount))
            //}
        });


        // 不管成不成功，把途经点展示出来，方便调试
        mapRemove(routeViaMarkRef.current);
        routeViaMarkRef.current = []


        // 16个点以下的简单路线，非会员、试用会员直接显示，赞赏会员会继续进行计算，以最少途经点呈现
        if (ways.length <= 16 && payVip == false) {
            routeViaMarkShow(waysCenter)
            //添加16个途经点可解决
            paramStr = `${startLnglat}&${endLnglat}`
            if (waysCenter.length > 0) {
                paramStr += `&${waysCenter.join(';')}`
            }

            setNaviParam(paramStr);

            // 非会员将不再支持导航，也就不用算最少途径了，节省接口调用
        } else if (vip == true || payVip == true) {
            // 距离过长，在不设置避让的情况下（android不支持），通过递归找出可还原路线所需的途经点。
            let tempWays = []
            let tempWaysCenter = []
            let tempWaysLast = [];

            let addWayCenter = [];

            let nextIndex = 0;
            const offsets = []

            //递归 + 循环，递归的是steps总共的组成条数，每条递归里循环 steps的组成条数，为了找到最匹配途经点，速度较慢，单导航准，2025-4-2 09:59:25，已较为优秀了
            const repeatWay = (index) => {
                nextIndex = index + 1;
                //超范围了还算个毛啊
                if (index < ways.length) {
                    // 只要在北京范围内的途经点 都要，防止在六环内外边上算不准，双重校验的时候再把六环范围外的途经点删了，防止过多不能导航
                    if (isBeiJingAll(stringToLngLat(ways[index])) || isBeiJingAll(stringToLngLat(waysCenter[index])) || isBeiJingAll(stringToLngLat(waysLast[index]))) {
                        //if (isBeiJingInside(stringToLngLat(ways[index])) || isBeiJingInside(stringToLngLat(waysCenter[index])) || isBeiJingInside(stringToLngLat(waysLast[index]))) {
                        restapi(startLnglatStr, ways[index], [], tempWays, strategy, (repeatResponse) => {
                            const repeatResult = repeatResponse.data;
                            if (repeatResult.status == 1) {

                                const repeatSteps = repeatResult.route.paths[0].steps;


                                //此次Index循环的偏移量个数
                                let offset = 0
                                //从上一个添加途径点的 step 的下一个 step 开始循环对比
                                for (let ri = (offsets.length > 0 ? _.last(offsets) + 1 : 0); ri < steps.length; ri++) {
                                    //有途经点会有偏移量，如果上一个路线被添加了途经点，当前step要对比 repeatSteps[当前+偏移量总个数]，
                                    if (offsets.indexOf(ri - 1) > -1) {
                                        offset = offsets.length;
                                    }
                                    //别超范围
                                    if (ri + offset < repeatSteps.length) {
                                        //对比相似度判断路线
                                        let sim = 0
                                        if (steps[ri].polyline == repeatSteps[ri + offset].polyline) {
                                            sim = 1
                                        } else {

                                            // sim = stringSimilarity(steps[ri].polyline, repeatSteps[ri + offset].polyline);
                                            if (steps[ri].polyline.length > 10000) {
                                                sim = stringSimilarity(steps[ri].polyline, repeatSteps[ri + offset].polyline);
                                            }
                                            else {
                                                sim = similarity(steps[ri].polyline, repeatSteps[ri + offset].polyline);
                                            }
                                        }

                                        if (sim < 0.98) {

                                            nextIndex = ri + 1;

                                            //有时会跳途经点，再设置前一个就来不及了，递归 + 循环，直接用此次 step 的索引值为途经点，下次循环从 ri+1 开始循环对比
                                            if (offsets.indexOf(ri) < 0) {
                                                tempWays.push(ways[ri])
                                                tempWaysCenter.push(waysCenter[ri])
                                                tempWaysLast.push(waysLast[ri])
                                                offsets.push(ri)
                                            }
                                            break;
                                        }
                                    }
                                }




                                if (redPolylineRef.current) {
                                    if (["localhost", "test.wintersir.com"].includes(window.location.hostname)) {
                                        map.remove(redPolylineRef.current)
                                    }
                                }
                                //渲染
                                const redPathLine = [];
                                repeatSteps.map(s => {
                                    s.polyline.split(';').map(ss => {
                                        const sss = ss.split(',');
                                        redPathLine.push(new AMap.LngLat(sss[0], sss[1]))
                                    })
                                })

                                var redPolyline = new AMap.Polyline({
                                    path: redPathLine,
                                    lineJoin: 'round',
                                    showDir: true,
                                    strokeColor: "red",  //线颜色
                                    strokeOpacity: 1,     //线透明度
                                    strokeWeight: 6,      //线宽
                                    strokeStyle: "solid"  //线样式
                                })
                                redPolylineRef.current = redPolyline;

                                if (["localhost", "test.wintersir.com"].includes(window.location.hostname)) {
                                    map.add(redPolyline);
                                }

                            }
                            repeatWay(nextIndex);
                        })
                    } else {
                        repeatWay(nextIndex);
                    }
                } else {

                    // 双重校验。
                    // 1、删掉六环外的，防止途经点过多不能导航（需要保留六环外最近的一个点，不然有问题）
                    // 2、用算出来的路线再反校验是不是把每一段path的头、中、尾，都走了，如果是，那么复现成功，如果有一个没走，就可能被拍
                    const redpathline = redPolylineRef.current?.getPath();
                    for (let againIndex = 0; againIndex < ways.length - 1; againIndex++) {
                        if (AMap.GeometryUtil.isPointOnLine(stringToLngLat(ways[againIndex]), redpathline, 1)
                            && AMap.GeometryUtil.isPointOnLine(stringToLngLat(waysCenter[againIndex]), redpathline, 1)
                            && AMap.GeometryUtil.isPointOnLine(stringToLngLat(waysLast[againIndex]), redpathline, 1)) {
                            continue;
                        } else {
                            // 这条path如果 头、中、尾，有一个没在路径上，用中去找是否在 tmmpWaysCenter中
                            let centerIndex = tempWaysCenter.indexOf(waysCenter[againIndex]);
                            // console.log(waysCenter[againIndex])

                            if (centerIndex > -1) {
                                //头没经过就插入头，尾没经过就插入尾
                                if (!AMap.GeometryUtil.isPointOnLine(stringToLngLat(ways[againIndex]), redpathline, 1)) {
                                    tempWaysCenter.splice(centerIndex, 0, ways[againIndex])
                                }
                                // 前面加了，索引会变，重新获取索引
                                centerIndex = tempWaysCenter.indexOf(waysCenter[againIndex]);
                                if (!AMap.GeometryUtil.isPointOnLine(stringToLngLat(waysLast[againIndex]), redpathline, 1)) {
                                    tempWaysCenter.splice(centerIndex + 1, 0, waysLast[againIndex])
                                }
                            } else {
                                // 这条path如果 头、中、尾，都没在路径上，证明偏航了，需要找到插入途经点的索引
                                for (let reIndex = againIndex - 1; reIndex > -1; reIndex--) {
                                    centerIndex = tempWaysCenter.indexOf(waysCenter[reIndex]);
                                    if (centerIndex > -1 && reIndex < waysCenter.length - 1) {
                                        // 找到要插入的索引，插入的是reIndex + 1的点
                                        tempWaysCenter.splice(centerIndex + 1, 0, waysCenter[reIndex + 1])
                                        break
                                    } else {
                                        continue
                                    }
                                }
                            }
                        }
                    }


                    // 只要六环内
                    const sixInside = tempWaysCenter.filter(f => isBeiJingInside(stringToLngLat(f)));
                    // 需要保留六环外最近的一个点，不然有问题，安卓会校验每段path，不需要这个逻辑
                    const firstIndex = tempWaysCenter.findIndex(f => f == sixInside[0]);
                    const lastIndex = tempWaysCenter.findIndex(f => f == _.last(sixInside));
                    if (firstIndex > 0 && !isBeiJingInside(tempWaysCenter[firstIndex - 1])) {
                        sixInside.unshift(tempWaysCenter[firstIndex - 1]);
                    }
                    if (lastIndex < tempWaysCenter.length - 1 && !isBeiJingInside(tempWaysCenter[lastIndex + 1])) {
                        sixInside.push(tempWaysCenter[lastIndex + 1]);
                    }

                    tempWaysCenter = sixInside;


                    if (tempWaysCenter.length > 16) {
                        log('路线较长，无法使用内置导航，建议分段 或 唤起高德手动减少途经点至16个以内导航');
                    }

                    let paramStr = `${startLnglat}&${endLnglat}`
                    if (waysCenter.length > 0 && tempWaysCenter.length > 0) {
                        paramStr += `&${tempWaysCenter.join(';')}`
                    }
                    //第四个参数，所有waycenter，让 Navi 校准补全途经点
                    if (tempWaysCenter.length > 0) {
                        // 没有途经点，就不需要校验补全
                        paramStr += `&${waysCenter.join(';')}`;
                    }

                    setNaviParam(paramStr);

                    routeViaMarkShow(tempWaysCenter);
                }
            }
            repeatWay(1); //从第二个途径点开始推算前一个途经点是否必要
        } else {
            log("普通用户不支持 “最少途经点” 功能，途经点过多无法导航！")
            setNaviVisable(false);
        }
    }



    const beforeJudge = (isJudgeVip = false, isClear = true) => {
        if (isClear) {
            clear()
        }
        if (version == null) {
            log(violation)
            return false
        }
        if (user == null) {
            setLoginOpen(true)
            return false
        }
        if (isJudgeVip && vip == false) {
            setVipInfoOpen(true)
            return false
        }
        return true
    }
    const beforeJudgeRef = (isJudgeVip = false, isClear = true) => {
        if (isClear) {
            clear()
        }
        if (version == null) {
            log(violation)
            return false
        }
        if (userRef.current == null) {
            setLoginOpen(true)
            return false
        }
        if (isJudgeVip && vipRef.current == false) {
            setVipInfoOpen(true)
            return false
        }
        return true
    }

    const UpdateDeviceAndAppVersion = () => {
        let deviceInfo = "";
        let appversion = "";
        if (who == "android") {
            deviceInfo = window?.Android?.JsCallAndroidGetDevice();

            if (window?.Android?.JsCallAndroidGetAppVersion) {
                appversion = window.Android.JsCallAndroidGetAppVersion();
            }
            else {
                log("请尽快更新至最新版" + (appSetting?.lastversion ?? ""))
            }

            if (deviceInfo == "" || deviceInfo == null || deviceInfo == undefined || deviceInfo.trim() == "") {
                deviceInfo = "android"
            }
        } else if (who == "ios") {

        } else if (who == "gzh") {
            deviceInfo = "gzh"
        } else {
            deviceInfo = "bs"
        }

        if (user != null && user.device !== deviceInfo) {
            //如果登录了，并且设备信息不一致，则更新
            axios.post('/api/updatedevice', {
                userid: user.id,
                device: deviceInfo
            })
        }
        if (user != null && appversion != "" && user.appversion !== appversion) {
            //如果登录了，App版本不一致，则更新
            axios.post('/api/updateappversion', {
                userid: user.id,
                appversion: appversion
            })
        }
        setDevice(deviceInfo);
    }

    const LoadTour = () => {
        //if (true) {
        if (user.tour != true) {
            if (localStorage.getItem("tour") == null) {
                setUpdateOpen(false)
                setLoginOpen(false)

                setTourOpen(true)

                localStorage.setItem("tour", dayjs().format("YYYY-MM-DD HH:mm:ss"))
                axios.post('/api/updatetour', {
                    userid: user.id,
                    tour: true
                })
            } else {
                log("请勿重复注册多个账号");
                setRepeatUser(true)
            }
        } else {
            setRepeatUser(false)
        }
    }

    const StartGaoDeNavi = () => {
        if (who == "gzh") {
            message.info("点击右上角···在浏览器中打开")
        } else {

            let schemeUrl = `amapuri://route/plan/?slon=${naviParam?.split('&')[0].split(',')[0]}&slat=${naviParam?.split('&')[0].split(',')[1]}&sname=${document.getElementById("txtStart").value}&dlon=${naviParam?.split('&')[1].split(',')[0]}&dlat=${naviParam?.split('&')[1].split(',')[1]}&dname=${document.getElementById("txtEnd").value}&dev=0&t=0`
            if (naviParam?.split('&').length > 2) {
                // 可能没有途经点，正好规划的就是高德默认路线
                schemeUrl += `&vian=${naviParam?.split('&')[2].split(";")?.length}&vialons=${naviParam?.split('&')[2].split(";")?.map((item) => item.split(",")[0]).join("|")}&vialats=${naviParam?.split('&')[2].split(";")?.map((item) => item.split(",")[1]).join("|")}&vianames=${naviParam?.split('&')[2].split(";")?.map((item, i) => `途经点${i + 1}`).join("|")}`
            }
            setNaviSchemeUrl(schemeUrl)
            confirm({
                title: '高德导航',
                closable: true,
                centered: true,
                icon: <ExclamationCircleFilled />,
                content: <div style={{ fontWeight: 500 }}>唤起高德后，根据 “最少途经点” 算法可能会出现多条路线，请谨慎选择和确认是否与规划路线一致，避免不必要的损失，若无一致路线，可参照规划路线手动增设途经点</div>,
                onOk() {
                    if (who == "android") {
                        if (window.Android.JsCallAndroidStartGaoDeNavi) {
                            window.Android.JsCallAndroidStartGaoDeNavi(schemeUrl)
                        } else {
                            log("请尽快更新至最新版" + (appSetting?.lastversion ?? ""))
                        }
                    } else {
                        //window.open(schemeUrl)
                        document.getElementById("naviSchemeUrlLink").click();
                    }
                }
            });
        }
    }

    const SixSvg = () => (
        <svg t="1741744876280" viewBox="0 0 1280 1024" version="1.1" p-id="15105" width="1.1em" height="1.1em"><path d="M511.488 0c36.864 0 76.032 5.632 117.504 16.896s71.168 28.672 89.088 52.224c17.92 23.552 26.88 46.592 26.88 69.12s-4.864 39.936-14.592 52.224c-9.728 12.288-21.248 18.432-34.56 18.432-13.312 0-26.88-4.096-40.704-12.288-13.824-8.192-44.544-35.328-92.16-81.408S488.704 42.24 483.072 34.56c-5.632-7.68-8.448-14.08-8.448-19.2 0-10.24 12.288-15.36 36.864-15.36z m557.568 304.128c62.464 0 109.568 10.24 141.312 30.72 31.744 20.48 47.616 39.424 47.616 56.832 0 22.528-30.208 33.792-90.624 33.792-22.528 0-50.944-2.048-85.248-6.144-34.304-4.096-80.64-6.144-139.008-6.144-123.904 0-267.52 9.728-430.848 29.184-163.328 19.456-276.736 38.4-340.224 56.832-23.552 6.144-43.776 9.216-60.672 9.216-16.896 0-39.68-7.936-68.352-23.808C14.336 468.736 0 456.704 0 448.512c0-8.192 13.312-13.312 39.936-15.36 74.752-3.072 237.824-21.504 489.216-55.296 251.392-33.792 397.056-54.528 436.992-62.208 39.936-7.68 74.24-11.52 102.912-11.52z m-356.352 264.192c16.384 0 61.952 24.576 136.704 73.728 74.752 49.152 127.488 93.952 158.208 134.4 30.72 40.448 46.08 78.336 46.08 113.664 0 35.328-3.328 60.672-9.984 76.032-6.656 15.36-16.128 23.04-28.416 23.04-18.432 0-38.4-17.92-59.904-53.76-31.744-53.248-72.192-114.176-121.344-182.784-49.152-68.608-83.456-113.152-102.912-133.632-19.456-20.48-29.184-34.048-29.184-40.704 0-6.656 3.584-9.984 10.752-9.984z m-187.392 107.52c0 12.288-10.496 24.064-31.488 35.328s-54.528 39.936-100.608 86.016-103.168 89.344-171.264 129.792-114.944 60.672-140.544 60.672c-7.168 0-10.752-3.072-10.752-9.216 0-6.144 10.24-16.384 30.72-30.72 89.088-66.56 157.952-130.048 206.592-190.464 48.64-60.416 70.912-101.888 66.816-124.416a176.170667 176.170667 0 0 1-1.536-21.504c0-20.48 7.168-30.72 21.504-30.72 14.336 0 39.68 12.288 76.032 36.864 36.352 24.576 54.528 44.032 54.528 58.368z" fill="#000000" p-id="15106"></path></svg>
    );
    return (
        allowinit ? <div className="App">
            <div id="container"></div>
            {
                <div id="loading" >
                    <div>{loadingText}</div>
                    <img width="18px" height="18px" src={loadingGIF} alt='' />
                    {/* <div id="loadingAnimationBox"><div id="loadingAnimationText">......</div></div> */}
                </div>
            }
            <div id="optionsControl" ref={ref0} className={`info${(isMobileOnly ? " mobile-control" : "")} `} style={{ padding: "10px 0 6px 0", minWidth: "25rem", marginTop: (who != "android" ? "0px" : "") }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1, marginLeft: 15 }}>
                        <div className="input-item">
                            <div className="input-item-prepend">
                                <span className="input-item-text input-item-text-span">起点</span>
                            </div>
                            <input id='txtStart' autoComplete='off' type="text" placeholder="请输入起点" lnglat={""} ></input>
                        </div>
                        {
                            // viaRef.current.map((v, vi) => {
                            //     const vp = v.position;
                            //     return <div className="input-item" key={"via" + vi}>
                            //         <div className="input-item-prepend">
                            //             <span className="input-item-text input-item-text-span">途径</span>
                            //         </div>
                            //         <input autoComplete='off' disabled="disabled" type="text" lnglat={vp.lng + "," + vp.lat} value={v.text} ></input>
                            //         <img onClick={() => {
                            //             clearVia(vi)
                            //         }} style={{ margin: '0px 5px', width: 20, height: 20, cursor: 'pointer' }} src={delWay}></img>
                            //     </div>
                            // })
                            <div className="input-item" style={{ display: viaRef.current.length > 0 ? "" : "none" }}>
                                <div className="input-item-prepend">
                                    <span className="input-item-text input-item-text-span">途径</span>
                                </div>
                                <input id='txtVia' autoComplete='off' type="text" lnglat={viaState ? (viaState.position.lng + "," + viaState.position.lat) : ""} ></input>
                                <img onClick={() => {
                                    clearVia(0)
                                }} style={{ margin: '0px 5px', width: 20, height: 20, cursor: 'pointer' }} src={delWay}></img>
                            </div>
                        }

                        <div className="input-item">
                            <div className="input-item-prepend">
                                <span className="input-item-text input-item-text-span">终点</span>
                            </div>
                            <input id='txtEnd' autoComplete='off' type="text" placeholder="请输入终点" lnglat={""} ></input>
                        </div>
                    </div>
                    <div className='exchange'>
                        <img className='exchange-image' src={exchangePNG} alt='' onClick={() => exchange()} />
                    </div>
                </div>
                <div className="input-item" style={{ justifyContent: 'center', flexWrap: 'wrap', height: 'auto', minHeight: '3rem', rowGap: '3px' }}>
                    <Button type="primary" id="go" className="button" onClick={() => {
                        if (camera.length == 0 || validCamera.length == 0) {
                            log("摄像头加载中。。。")
                            return
                        }
                        if (repeatUser) {
                            log("请勿重复注册多个账号");
                            return
                        }
                        mapRemove(longMarkRef.current); mapRemove(locateRef.current);
                        autoIndexRef.current = null; autoRoutesRef.current = []; apiCount.current = []; timeS.current = performance.now(); console.clear()
                        goBefore()
                    }}>走你 {sixDoorAuto ? "(自)" : ""}{(!vip || !payVip) && user != null && remain}</Button>
                    {
                        sixDoorAuto && sixDoorMode > 1 && autoRoutesRef.current.length > 0 && <Button type="primary" className="button" iconPosition="end" onClick={() => {
                            setAutoRoutesShow(true)
                        }}>路线</Button>
                    }
                    {
                        naviVisable && who == "android" && <Button type="primary" className="button" iconPosition="end" loading={naviParam == null} onClick={() => {
                            try {
                                if (naviParam == null) {
                                    log('导航失败，请联系作者')
                                } else if (beforeJudge(true)) {
                                    //console.log(naviParam)
                                    window.Android.JsCallAndroidNavi(naviParam);
                                    //window.webkit.messageHandlers.JsCallIOSNaviInterface.postMessage(naviParam)
                                }
                            } catch (error) {
                                beforeJudge()
                            }
                        }}>导航</Button>
                    }
                    {
                        naviVisable && <Button type="primary" className="button" iconPosition="end" loading={naviParam == null}
                            onClick={() => {
                                if (payVip) {
                                    StartGaoDeNavi()
                                } else {
                                    setVipInfoOpen(true)
                                }
                            }}

                        >高德</Button>
                    }
                    {
                        naviVisable && <a id="naviSchemeUrlLink" style={{ display: 'none' }} href={naviSchemeUrl}></a>
                    }
                    {
                        starVisable && <Button className="button" type="primary" onClick={() => {
                            if (beforeJudge(true)) {
                                if (document.getElementById('txtStart').value == "" || document.getElementById('txtStart').getAttribute("lnglat") == "" || document.getElementById('txtEnd').value == "" || document.getElementById('txtEnd').getAttribute("lnglat") == "") {
                                    log("起点或终点不能为空")
                                    return
                                }

                                const via = viaRef.current[0];
                                const payload = {
                                    userid: user.id,
                                    startaddress: (document.getElementById('txtStart').value == "我的位置" ? GaolocationRef.current.address : document.getElementById('txtStart').value),
                                    startposition: document.getElementById('txtStart').getAttribute("lnglat"),
                                    endaddress: (document.getElementById('txtEnd').value == "我的位置" ? GaolocationRef.current.address : document.getElementById('txtEnd').value),
                                    endposition: document.getElementById('txtEnd').getAttribute("lnglat"),
                                    viaaddress: via?.text,
                                    viaposition: via ? lngLatToString(via.position) : ""
                                }
                                axios.post('/api/addcollectsroute', payload).then(function (response) {
                                    if (response.data == "code1") {
                                        log("真的不能再多了")
                                    } else {
                                        message.success({ content: "收藏成功", style: { marginTop: "100px" } });
                                        setStarTip(true);
                                        setTimeout(() => {
                                            setStarTip(false);
                                        }, 2000);
                                    }
                                }).catch(function (error) {
                                    console.log("/addcamera" + error);
                                    log("收藏路线失败");
                                })
                            }
                        }}>收藏</Button>
                    }
                </div>
                <div className="input-item" id="drivingResult"></div>
            </div>

            {/* 左下角 - 最近更新 */}
            <div id="update-modal" className="info show-update" ref={ref1} onClick={() => setUpdateOpen(true)}>更新：{dayjs(newCamera[0]?.checktime)?.format('YYYY-MM-DD')}</div>
            <LastUpdate updateOpen={updateOpen} setUpdateOpen={setUpdateOpen} updateClose={updateClose} newCamera={newCamera} isMobileOnly={isMobileOnly}></LastUpdate>

            {/* 底部中 - 赞赏 */}
            <div className="info show-support" onClick={() => { setSupportOpen(true) }}><LikeTwoTone /></div>
            <SupportPage supportOpen={supportOpen} setSupportOpen={setSupportOpen}></SupportPage>

            {/* 右下角 - 显示全部摄像头 */}
            <Checkbox.Group className='info show-camare' value={showCamera} ref={ref2} onChange={e => {
                if (camera.length > 0) {
                    setShowCamera(e)
                } else {
                    log("摄像头加载中。。。")
                }
            }}>
                <Checkbox value="all" style={{ fontSize: 12, padding: '4px 0px 4px 10px' }} >显示摄像头</Checkbox>
                <Dropdown placement="top" open={cameraMore} onClick={() => setCameraMore(!cameraMore)} menu={{
                    items: [
                        { label: <div style={{ display: 'flex', alignItems: 'center' }}><Checkbox value="new" style={{ fontSize: 12, fontWeight: 600, marginRight: 10 }} >最新 </Checkbox><img style={{ width: 21, height: 27 }} src={camNew} /></div> },
                        { label: <div style={{ display: 'flex', alignItems: 'center' }}><Checkbox value="temp" style={{ fontSize: 12, fontWeight: 600, marginRight: 10 }} >暂停 </Checkbox><img style={{ width: 21, height: 27 }} src={camTem} /></div> },
                        { label: <div style={{ display: 'flex', alignItems: 'center' }}><Checkbox value="high" style={{ fontSize: 12, fontWeight: 600, marginRight: 10 }} >高峰 </Checkbox><img style={{ width: 21, height: 27 }} src={camHigh} /></div> }
                    ]
                }} >
                    <a onClick={(e) => e.preventDefault()} style={{ cursor: "pointer", padding: "0px 10px" }}>
                        {cameraMore ? <DownOutlined /> : <UpOutlined />}
                    </a>
                </Dropdown>
            </Checkbox.Group>


            {/* 用户-悬浮按钮 */}

            <FloatButton ref={ref4} className='floatbutton' style={{ insetBlockEnd: 315 }} icon={user == null ? <UserOutlined /> : <SmileOutlined />}
                onClick={() => {
                    if (user != null) {
                        //每次点开个人信息都刷新，主要是为了即时更新会员过期时间，防止会员充值后还要杀app或者退出app才能刷新
                        getUser();
                    }
                    try {
                        //带版本号的链接，证明app已更新至支持缓存的版本（大于 v1.1）
                        if (beforeJudge()) {
                            UpdateDeviceAndAppVersion();
                            setLoginOpen(true);
                        }
                    } catch (e) {
                        beforeJudge();
                        log("无效链接")
                        emailfromjs(e.stack, "userfloatbutton")
                    }
                }}>
            </FloatButton>

            <LoginPage loginOpen={loginOpen} setLoginOpen={setLoginOpen} vipInfoOpen={vipInfoOpen} setVipInfoOpen={setVipInfoOpen} device={device} user={user}
                setUser={setUser} authorShow={authorShow} setAuthorShow={setAuthorShow} ></LoginPage>


            {/* 收藏-悬浮按钮 */}
            <FloatButton ref={ref5} className='floatbutton' style={{ insetBlockEnd: 270, backgroundColor: 'white' }} icon={<StarOutlined />} onClick={() => {
                if (beforeJudge(true)) {
                    setStarOpen(true);
                }
            }} />
            <StarPage starOpen={starOpen} setStarOpen={setStarOpen} user={user} setStartAndEnd={setStartAndEnd} setVia={setVia} stringToLngLat={stringToLngLat} getUserExcludeCamera={getUserExcludeCamera} userExcludeCamera={userExcludeCamera}></StarPage>

            {/* 六环 */}
            <FloatButton ref={ref6} className='floatbutton' style={{ insetBlockEnd: 225 }} icon={<Icon component={SixSvg}></Icon>}
                onClick={() => { setSixDoorOpen(true) }}>
            </FloatButton>
            <SixDoorPage sixDoorOpen={sixDoorOpen} setSixDoorOpen={setSixDoorOpen} setStartAndEnd={setStartAndEnd} setVia={setVia} stringToLngLat={stringToLngLat}
                sixDoorData={sixdoor} vip={vip} payVip={payVip} start={startMarkRef.current} end={endMarkRef.current} locate={locateRef.current} AMap={AMap}
                sixDoorAuto={sixDoorAuto} setSixDoorAuto={setSixDoorAuto} sixDoorMode={sixDoorMode} setSixDoorMode={setSixDoorMode} startCloserSixDoor={startCloserSixDoor}
                setStartCloserSixDoor={setStartCloserSixDoor} endCloserSixDoor={endCloserSixDoor} setEndCloserSixDoor={setEndCloserSixDoor} setVipInfoOpen={setVipInfoOpen}
            ></SixDoorPage>


            {/* 时间线-悬浮按钮 */}
            <FloatButton ref={ref7} badge={{ dot: read }} className='floatbutton' style={{ insetBlockEnd: 180 }} onClick={() => {
                if (version >= 2 && localStorage.getItem("read") == null) {
                    localStorage.setItem("read", dayjs().format('YYYY-MM-DD HH:mm:ss'));
                    setRead(false);
                }
                setTimeLineVisible(true)
            }} />
            <TimeLinePage timelineData={timelineData} timeLineVisible={timeLineVisible} setTimeLineVisible={setTimeLineVisible} log={log}></TimeLinePage>


            {/* 定位 */}
            <FloatButton onClick={() => {
                if (who == "gzh") {
                    WXGetLocation()
                } else if (who == "android") {
                    if (window.Android.JsCallAndroidGetLocation) {
                        window.Android.JsCallAndroidGetLocation()
                    } else {
                        log("定位功能最低支持 v2.2", 0, true)
                    }
                } else {
                    BrowserLocation()
                }
            }} className='floatbutton' style={{ insetBlockEnd: 135 }} icon={<AimOutlined />}></FloatButton>


            {/* 地图缩放-悬浮按钮 + - */}
            <div className='floatbutton' style={{ width: 32, marginRight: 1, borderRadius: 5, height: 'auto', insetBlockEnd: 55, display: 'flex', flexDirection: "column", position: 'fixed', fontSize: 17, alignItems: 'center' }}>
                <PlusOutlined onClick={() => { map.setZoom(map.getZoom() + 1) }} style={{ padding: 8, width: 32 }} />
                <MinusOutlined onClick={() => { map.setZoom(map.getZoom() - 1) }} style={{ padding: 8, width: 32, borderTop: '1px solid #eeeeee' }} />
            </div>


            {/* 自动路线弹框 */}
            <Modal
                open={autoRoutesShow}
                centered
                title={null}
                footer={null}
                width={'90%'}
                destroyOnHidden={true}
                onCancel={() => setAutoRoutesShow(false)}
            >
                {
                    _.orderBy(autoRoutesRef.current, ['duration', 'distance'], ['asc', 'asc']).map((c, ci) => {
                        const needTime = formatSeconds(c.duration);
                        const needDistance = (c.distance / 1000).toFixed(2);
                        return <div key={"autoRoutes" + ci} className="collect-item" style={ci == autoRoutesRef.current.length - 1 ? { borderBottom: "0px" } : {}}>
                            <div style={{ display: "flex", alignItems: 'center' }}>
                                <div style={{ flex: 1, wordSpacing: 5, fontWeight: 500 }}>
                                    {`第${ci + 1}条：${needTime} · ${needDistance}公里`}
                                </div>
                                <div style={{ width: 45, fontSize: 16, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <CarTwoTone style={{ fontSize: 16 }} onClick={() => {
                                        //清除上条导航参数
                                        setNaviParam(null);
                                        //清除上条导航途径标记
                                        mapRemove(routeViaMarkRef.current);
                                        routeViaMarkRef.current = []
                                        //清除上条导航结果
                                        document.getElementById("drivingResult").innerHTML = "";
                                        //设置这次导航参数
                                        setVia(c.via.position, c.via.text)
                                        timeS.current = performance.now();
                                        goSuccess(c.result, c.startLnglatStr, c.endLnglatStr, c.strategy);
                                        setAutoRoutesShow(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    })
                }
            </Modal>


            {/* Author */}
            {
                user?.admin && authorShow &&
                <Suspense fallback={""}>
                    <AuthorPage vip={vip} getUser={getUser} isMobileOnly={isMobileOnly} map={map} AMap={AMap} camera={camera} setCamera={setCamera}
                        createCamarePolygon={createCamarePolygon} camPot={camPot} log={log} selectSingleCamera={camareMarkRef.current} clickPosition={longMarkRef.current == null ? "" : lngLatToString(longMarkRef.current?._position)}>
                    </AuthorPage>
                </Suspense>
            }


            {/* 漫游指引 */}
            <Tour zIndex={3000} open={tourOpen} onClose={() => {
                setTourOpen(false);
            }} steps={TourSteps} />

            <Image.PreviewGroup
                preview={{
                    visible: camImageOpen,
                    onVisibleChange: (value) => {
                        setCamImageOpen(value);
                        if (value == false) {
                            setCamImageUrl("");
                        }
                    },
                }}
                //items={["/upload/cameraimage/20250729_170028046.jpg","/upload/cameraimage/20250630_133836666.jpg"]}
                items={camImageUrl.indexOf("|") > -1 ? camImageUrl.split("|").map(url => "/upload" + url) : ["/upload" + camImageUrl]}
            >
                {/* <Image
                    width={200}
                    style={{ display: 'none' }}
                    src={camImageUrl == "" ? "" : ('/upload' + camImageUrl)}
                    preview={{
                        visible: camImageOpen,
                        src: camImageUrl == "" ? "" : ('/upload' + camImageUrl),
                        onVisibleChange: (value) => {
                            setCamImageOpen(value);
                            if (value == false) {
                                setCamImageUrl("");
                            }
                        },
                    }}
                /> */}

            </Image.PreviewGroup>

        </div> : <div style={{ width: '100%', marginTop: '5rem', padding: '2rem', fontSize: 14, fontWeight: 600, display: 'flex', justifyContent: 'center' }} dangerouslySetInnerHTML={{ __html: violation }} />)
}
export default App;
